/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export enum ApiEstimationMode {
  GUIDED = 'GUIDED',
  DETAILED = 'DETAILED',
}

export enum ReviewOutcome {
  COMPLETED = 'COMPLETED',
  CANCELED = 'CANCELED',
}

/** @format int64 */
export enum Permissions {
  Value0 = 0,
  Value1 = 1,
  Value2 = 2,
  Value4 = 4,
  Value8 = 8,
  Value16 = 16,
  Value32 = 32,
  Value64 = 64,
  Value128 = 128,
  Value256 = 256,
  Value512 = 512,
  Value1024 = 1024,
  Value2048 = 2048,
  Value4096 = 4096,
  Value8192 = 8192,
  Value16384 = 16384,
  Value32768 = 32768,
  Value65536 = 65536,
  Value131072 = 131072,
  Value262144 = 262144,
  Value524288 = 524288,
  Value1048576 = 1048576,
  Value2097152 = 2097152,
  Value4194304 = 4194304,
  Value8388608 = 8388608,
  Value16777216 = 16777216,
  Value33554432 = 33554432,
  Value67108864 = 67108864,
  Value134217728 = 134217728,
  Value268435456 = 268435456,
  Value536870912 = 536870912,
  Value1073741824 = 1073741824,
  Value2147483648 = 2147483648,
  Value4294967296 = 4294967296,
  Value8589934592 = 8589934592,
  Value17179869184 = 17179869184,
  Value34359738368 = 34359738368,
  Value68719476736 = 68719476736,
  Value137438953472 = 137438953472,
  Value274877906944 = 274877906944,
}

export enum NotificationType {
  USER_ASSIGNED_AS_CONTRIBUTOR_TO_ESTIMATION = 'USER_ASSIGNED_AS_CONTRIBUTOR_TO_ESTIMATION',
  USER_ASSIGNED_AS_PLANNING_RESPONSIBLE_TO_ESTIMATION = 'USER_ASSIGNED_AS_PLANNING_RESPONSIBLE_TO_ESTIMATION',
  USER_ASSIGNED_AS_PHASE_LEAD_TO_ESTIMATION_ITEM = 'USER_ASSIGNED_AS_PHASE_LEAD_TO_ESTIMATION_ITEM',
  COMMENT_ADDED_TO_ESTIMATION_ITEM = 'COMMENT_ADDED_TO_ESTIMATION_ITEM',
  ESTIMATION_REVIEW_CANCELLED = 'ESTIMATION_REVIEW_CANCELLED',
  ESTIMATION_REVIEW_REQUESTED = 'ESTIMATION_REVIEW_REQUESTED',
  ESTIMATION_APPROVED = 'ESTIMATION_APPROVED',
  ESTIMATION_NEW_VERSION_CREATED = 'ESTIMATION_NEW_VERSION_CREATED',
  USER_ASSIGNED_AS_REVIEWER_TO_ESTIMATION = 'USER_ASSIGNED_AS_REVIEWER_TO_ESTIMATION',
  ESTIMATION_AI_REVIEW_CREATED = 'ESTIMATION_AI_REVIEW_CREATED',
  REVIEW_COMMENTS_SUMMARY_AVAILABLE = 'REVIEW_COMMENTS_SUMMARY_AVAILABLE',
  ESTIMATION_REVIEW_OUTCOME = 'ESTIMATION_REVIEW_OUTCOME',
  PHASE_STATUS_CHANGED = 'PHASE_STATUS_CHANGED',
  PHASE_BLOCKED = 'PHASE_BLOCKED',
  PHASE_UNBLOCKED = 'PHASE_UNBLOCKED',
  ITEM_ASSIGNED_TO_PHASE = 'ITEM_ASSIGNED_TO_PHASE',
  PHASE_DEADLINE_APPROACHING = 'PHASE_DEADLINE_APPROACHING',
  CONVERSATION_SHARED = 'CONVERSATION_SHARED',
}

export enum NotificationDeliveryMode {
  NONE = 'NONE',
  IN_APP = 'IN_APP',
  EMAIL = 'EMAIL',
  BOTH = 'BOTH',
}

/** @format int32 */
export enum MaintenanceBannerType {
  Info = 0,
  Warning = 1,
  Critical = 2,
}

export enum EstimationUnit {
  PD = 'PD',
  HOURS = 'HOURS',
  STORY_POINTS = 'STORY_POINTS',
  CURRENCY = 'CURRENCY',
}

/** @format int32 */
export enum EstimationModelItemGroupLevel {
  Phase = 0,
  SubPhase = 1,
}

export enum ApiSortUsersBy {
  FORENAME = 'FORENAME',
  SURNAME = 'SURNAME',
  EMAIL = 'EMAIL',
}

export enum ApiSortNotificationsBy {
  CREATED_AT = 'CREATED_AT',
}

export enum ApiSortEstimationsPerProjectBy {
  PROJECT_NAME = 'PROJECT_NAME',
  ESTIMATION_CREATED_AT = 'ESTIMATION_CREATED_AT',
  ESTIMATION_UPDATED_AT = 'ESTIMATION_UPDATED_AT',
  ESTIMATION_CREATED_BY = 'ESTIMATION_CREATED_BY',
  ESTIMATION_CALCULATED_RESULT = 'ESTIMATION_CALCULATED_RESULT',
  ESTIMATION_PLANNING_RESPONSIBLE = 'ESTIMATION_PLANNING_RESPONSIBLE',
  ESTIMATION_METHODOLOGY = 'ESTIMATION_METHODOLOGY',
  PROJECT_TYPE = 'PROJECT_TYPE',
  ESTIMATION_STAGE = 'ESTIMATION_STAGE',
  ESTIMATION_UNIT = 'ESTIMATION_UNIT',
}

export enum ApiPermission {
  NONE = 'NONE',
  CAN_CREATE_ESTIMATION_VERSION_IN_ANY_PROJECT = 'CAN_CREATE_ESTIMATION_VERSION_IN_ANY_PROJECT',
  CAN_CREATE_ESTIMATION = 'CAN_CREATE_ESTIMATION',
  CAN_VIEW_ESTIMATIONS = 'CAN_VIEW_ESTIMATIONS',
  CAN_EDIT_ESTIMATIONS = 'CAN_EDIT_ESTIMATIONS',
  CAN_DELETE_ESTIMATIONS = 'CAN_DELETE_ESTIMATIONS',
  CAN_APPROVE_ESTIMATIONS = 'CAN_APPROVE_ESTIMATIONS',
  CAN_COMMENT_ESTIMATIONS = 'CAN_COMMENT_ESTIMATIONS',
  CAN_VIEW_ESTIMATION_USERS = 'CAN_VIEW_ESTIMATION_USERS',
  CAN_EDIT_ESTIMATION_USERS = 'CAN_EDIT_ESTIMATION_USERS',
  CAN_VIEW_DASHBOARD = 'CAN_VIEW_DASHBOARD',
  CAN_MANAGE_DASHBOARD = 'CAN_MANAGE_DASHBOARD',
  CAN_START_ESTIMATION_WIZARD = 'CAN_START_ESTIMATION_WIZARD',
  CAN_COMPLETE_ESTIMATION_WIZARD = 'CAN_COMPLETE_ESTIMATION_WIZARD',
  CAN_CREATE_CUSTOM_ESTIMATION_ITEMS = 'CAN_CREATE_CUSTOM_ESTIMATION_ITEMS',
  CAN_SWITCH_TO_EXPERT_MODE = 'CAN_SWITCH_TO_EXPERT_MODE',
  CAN_BE_REVIEWER = 'CAN_BE_REVIEWER',
  CAN_UPLOAD_TENANT_LOGO = 'CAN_UPLOAD_TENANT_LOGO',
  CAN_PUBLISH_ESTIMATION_MODEL = 'CAN_PUBLISH_ESTIMATION_MODEL',
  CAN_VIEW_ADMINISTRATION = 'CAN_VIEW_ADMINISTRATION',
  CAN_VIEW_TENANT_ADMINISTRATION = 'CAN_VIEW_TENANT_ADMINISTRATION',
  CAN_EDIT_ADMINISTRATION = 'CAN_EDIT_ADMINISTRATION',
  CAN_EDIT_TENANT_ADMINISTRATION = 'CAN_EDIT_TENANT_ADMINISTRATION',
  CAN_VIEW_TENANT_SETTINGS = 'CAN_VIEW_TENANT_SETTINGS',
  CAN_MANAGE_TENANT_SETTINGS = 'CAN_MANAGE_TENANT_SETTINGS',
  CAN_VIEW_INDIVIDUALISATION = 'CAN_VIEW_INDIVIDUALISATION',
  CAN_MANAGE_INDIVIDUALISATION = 'CAN_MANAGE_INDIVIDUALISATION',
  CAN_VIEW_PROJECT_TYPES = 'CAN_VIEW_PROJECT_TYPES',
  CAN_MANAGE_PROJECT_TYPES = 'CAN_MANAGE_PROJECT_TYPES',
  CAN_VIEW_ESTIMATION_METHODOLOGIES = 'CAN_VIEW_ESTIMATION_METHODOLOGIES',
  CAN_MANAGE_ESTIMATION_METHODOLOGIES = 'CAN_MANAGE_ESTIMATION_METHODOLOGIES',
  CAN_VIEW_ESTIMATION_MODELS = 'CAN_VIEW_ESTIMATION_MODELS',
  CAN_MANAGE_ESTIMATION_MODELS = 'CAN_MANAGE_ESTIMATION_MODELS',
  CAN_VIEW_USERS = 'CAN_VIEW_USERS',
  CAN_MANAGE_USERS = 'CAN_MANAGE_USERS',
  CAN_VIEW_WORKFLOW = 'CAN_VIEW_WORKFLOW',
  CAN_MANAGE_WORKFLOW = 'CAN_MANAGE_WORKFLOW',
  CAN_CREATE_ESTIMATION_VERSION_IN_MY_PROJECT = 'CAN_CREATE_ESTIMATION_VERSION_IN_MY_PROJECT',
  CAN_USE_AI_ADVISORY = 'CAN_USE_AI_ADVISORY',
}

export enum ApiLogoType {
  NORMAL = 'NORMAL',
  DARK_MODE = 'DARK_MODE',
}

/** Indicates how an estimation model item's value is determined. */
export enum ApiIsCalculatedMode {
  NONE = 'NONE',
  PARAM_FORMULA = 'PARAM_FORMULA',
  FORMULA = 'FORMULA',
}

export enum ApiEstimationUserAssignmentType {
  CONTRIBUTOR = 'CONTRIBUTOR',
  PLANNING_RESPONSIBLE = 'PLANNING_RESPONSIBLE',
  REVIEWER = 'REVIEWER',
}

export enum ApiEstimationStage {
  IN_CREATION = 'IN_CREATION',
  IN_PROCESS = 'IN_PROCESS',
  IN_REVIEW = 'IN_REVIEW',
  APPROVED = 'APPROVED',
}

export enum ApiEstimationPermission {
  NONE = 'NONE',
  CAN_VIEW = 'CAN_VIEW',
  CAN_EDIT = 'CAN_EDIT',
  CAN_DELETE = 'CAN_DELETE',
  CAN_APPROVE = 'CAN_APPROVE',
  CAN_COMMENT = 'CAN_COMMENT',
  CAN_VIEW_USERS = 'CAN_VIEW_USERS',
  CAN_EDIT_USERS = 'CAN_EDIT_USERS',
  CAN_REVIEW = 'CAN_REVIEW',
  CAN_CREATE_NEW_VERSION = 'CAN_CREATE_NEW_VERSION',
}

export enum ApiEstimationItemStatus {
  CONSIDERED_FOR_ESTIMATION = 'CONSIDERED_FOR_ESTIMATION',
  OMITTED = 'OMITTED',
  ESTIMATED = 'ESTIMATED',
}

export enum ApiEstimationItemPurpose {
  RESOURCE = 'RESOURCE',
  COST = 'COST',
}

export enum ApiEstimationAdditionalFieldType {
  TEXT = 'TEXT',
  FORMATTED_TEXT = 'FORMATTED_TEXT',
  DURATION_TIME_SPAN = 'DURATION_TIME_SPAN',
  SELECTABLE = 'SELECTABLE',
  DATE = 'DATE',
  DOCUMENT_LINK = 'DOCUMENT_LINK',
}

export enum ApiErrorCode {
  GENERAL = 'GENERAL',
  VALIDATION = 'VALIDATION',
  DOMAIN_ERROR = 'DOMAIN_ERROR',
  ENTITY_NOT_FOUND = 'ENTITY_NOT_FOUND',
  ESTIMATION_ITEM_ASSUMPTION_NOT_FOUND = 'ESTIMATION_ITEM_ASSUMPTION_NOT_FOUND',
  ESTIMATION_ITEM_NOT_FOUND = 'ESTIMATION_ITEM_NOT_FOUND',
  ESTIMATION_NOT_FOUND = 'ESTIMATION_NOT_FOUND',
  PROJECT_TYPE_CURRENCY_NOT_FOUND = 'PROJECT_TYPE_CURRENCY_NOT_FOUND',
  PROJECT_TYPE_NOT_FOUND = 'PROJECT_TYPE_NOT_FOUND',
  PROJECT_NOT_FOUND = 'PROJECT_NOT_FOUND',
  ESTIMATION_COST_NOT_FOUND = 'ESTIMATION_COST_NOT_FOUND',
  RESOURCE_TYPE_COST_NOT_FOUND = 'RESOURCE_TYPE_COST_NOT_FOUND',
  USER_NOT_FOUND = 'USER_NOT_FOUND',
  USER_ALREADY_EXISTS = 'USER_ALREADY_EXISTS',
  LOCALIZATION_NOT_FOUND = 'LOCALIZATION_NOT_FOUND',
  ESTIMATION_USER_ASSIGNMENT_NOT_FOUND = 'ESTIMATION_USER_ASSIGNMENT_NOT_FOUND',
  ESTIMATION_MODEL_ITEM_NOT_FOUND = 'ESTIMATION_MODEL_ITEM_NOT_FOUND',
  ESTIMATION_ITEM_COMMENT_NOT_FOUND = 'ESTIMATION_ITEM_COMMENT_NOT_FOUND',
  ESTIMATION_COMMENT_NOT_FOUND = 'ESTIMATION_COMMENT_NOT_FOUND',
  COMMENT_BASE_NOT_FOUND = 'COMMENT_BASE_NOT_FOUND',
  TENANT_NOT_FOUND = 'TENANT_NOT_FOUND',
  ROLE_NOT_FOUND = 'ROLE_NOT_FOUND',
  PROJECT_NOTIFICATION_NOT_FOUND = 'PROJECT_NOTIFICATION_NOT_FOUND',
  NOTIFICATION_BASE_NOT_FOUND = 'NOTIFICATION_BASE_NOT_FOUND',
  ESTIMATION_NOTIFICATION_NOT_FOUND = 'ESTIMATION_NOTIFICATION_NOT_FOUND',
  ESTIMATION_ITEM_NOTIFICATION_NOT_FOUND = 'ESTIMATION_ITEM_NOTIFICATION_NOT_FOUND',
  COMMENT_NOTIFICATION_NOT_FOUND = 'COMMENT_NOTIFICATION_NOT_FOUND',
  ESTIMATION_MODEL_UNIT_NOT_FOUND = 'ESTIMATION_MODEL_UNIT_NOT_FOUND',
  ESTIMATION_MODEL_ITEM_PARAMETER_NOT_FOUND = 'ESTIMATION_MODEL_ITEM_PARAMETER_NOT_FOUND',
  ESTIMATION_MODEL_ASSUMPTION_CATEGORY_NOT_FOUND = 'ESTIMATION_MODEL_ASSUMPTION_CATEGORY_NOT_FOUND',
  ESTIMATION_MODEL_ADDITIONAL_FIELD_DEFINITION_NOT_FOUND = 'ESTIMATION_MODEL_ADDITIONAL_FIELD_DEFINITION_NOT_FOUND',
  ESTIMATION_MODEL_NOT_FOUND = 'ESTIMATION_MODEL_NOT_FOUND',
  METHODOLOGY_PARAMETER_NOT_FOUND = 'METHODOLOGY_PARAMETER_NOT_FOUND',
  METHODOLOGY_NOT_FOUND = 'METHODOLOGY_NOT_FOUND',
  ESTIMATION_ITEM_RESOURCE_NOT_FOUND = 'ESTIMATION_ITEM_RESOURCE_NOT_FOUND',
  ESTIMATION_ITEM_COST_NOT_FOUND = 'ESTIMATION_ITEM_COST_NOT_FOUND',
  ESTIMATION_ITEM_PARAMETER_NOT_FOUND = 'ESTIMATION_ITEM_PARAMETER_NOT_FOUND',
  ESTIMATION_ASSUMPTION_NOT_FOUND = 'ESTIMATION_ASSUMPTION_NOT_FOUND',
  ESTIMATION_ADDITIONAL_FIELD_NOT_FOUND = 'ESTIMATION_ADDITIONAL_FIELD_NOT_FOUND',
  CURRENCY_CONVERSION_RATE_NOT_FOUND = 'CURRENCY_CONVERSION_RATE_NOT_FOUND',
  ESTIMATION_MODEL_METHODOLOGY_NOT_FOUND = 'ESTIMATION_MODEL_METHODOLOGY_NOT_FOUND',
  RESOURCE_TYPE_NOT_FOUND = 'RESOURCE_TYPE_NOT_FOUND',
  COST_TYPE_NOT_FOUND = 'COST_TYPE_NOT_FOUND',
  CURRENCY_NOT_FOUND = 'CURRENCY_NOT_FOUND',
  CALCULATION_FORMULA_EVALUATION_ERROR = 'CALCULATION_FORMULA_EVALUATION_ERROR',
  CALCULATION_MISSING_INPUT_DATA = 'CALCULATION_MISSING_INPUT_DATA',
  CALCULATION_MISSING_PARAMETER_VALUE = 'CALCULATION_MISSING_PARAMETER_VALUE',
  WRONG_ASSUMPTION_CATEGORY = 'WRONG_ASSUMPTION_CATEGORY',
  WRONG_UNIT = 'WRONG_UNIT',
  WRONG_ESTIMATION_UNIT_PARENT = 'WRONG_ESTIMATION_UNIT_PARENT',
  CALCULATED_ESTIMATION_ITEM_CANNOT_HAVE_PARAMS = 'CALCULATED_ESTIMATION_ITEM_CANNOT_HAVE_PARAMS',
  CALCULATED_ESTIMATION_ITEM_CANNOT_HAVE_METHODOLOGY = 'CALCULATED_ESTIMATION_ITEM_CANNOT_HAVE_METHODOLOGY',
  UNCALCULATED_ESTIMATION_ITEM_MUST_HAVE_PARAMS = 'UNCALCULATED_ESTIMATION_ITEM_MUST_HAVE_PARAMS',
  METHODOLOGY_CANNOT_BE_SET_WHEN_MODEL_ITEM_HAS_PARAMS = 'METHODOLOGY_CANNOT_BE_SET_WHEN_MODEL_ITEM_HAS_PARAMS',
  METHODOLOGY_UNSUPPORTED_BY_MODEL = 'METHODOLOGY_UNSUPPORTED_BY_MODEL',
  OMIT_REASON_CAN_ONLY_BE_SET_FOR_OMITTED_ESTIMATION_ITEM = 'OMIT_REASON_CAN_ONLY_BE_SET_FOR_OMITTED_ESTIMATION_ITEM',
  OMIT_REASON_MUST_BE_SET_FOR_OMITTED_ESTIMATION_ITEM = 'OMIT_REASON_MUST_BE_SET_FOR_OMITTED_ESTIMATION_ITEM',
  ESTIMATION_ADDITIONAL_FIELD_WRONG_DEFINITION = 'ESTIMATION_ADDITIONAL_FIELD_WRONG_DEFINITION',
  CANNOT_PARSE_ADDITIONAL_FIELD_OF_TYPE_DURATION = 'CANNOT_PARSE_ADDITIONAL_FIELD_OF_TYPE_DURATION',
  CANNOT_PARSE_ADDITIONAL_FIELD_OF_TYPE_DATE = 'CANNOT_PARSE_ADDITIONAL_FIELD_OF_TYPE_DATE',
  CANNOT_PARSE_ADDITIONAL_FIELD_OF_TYPE_DOCUMENT_LINK = 'CANNOT_PARSE_ADDITIONAL_FIELD_OF_TYPE_DOCUMENT_LINK',
  ESTIMATION_ADDITIONAL_FIELD_OF_TYPE_SELECTABLE_CONTAINS_WRONG_VALUE = 'ESTIMATION_ADDITIONAL_FIELD_OF_TYPE_SELECTABLE_CONTAINS_WRONG_VALUE',
  ESTIMATION_STAGE_MUST_BE_IN_REVIEW_WHEN_CHANGING_TO_APPROVED_STAGE = 'ESTIMATION_STAGE_MUST_BE_IN_REVIEW_WHEN_CHANGING_TO_APPROVED_STAGE',
  ESTIMATION_STAGE_MUST_BE_IN_PROCESS_WHEN_CHANGING_TO_IN_REVIEW_STAGE = 'ESTIMATION_STAGE_MUST_BE_IN_PROCESS_WHEN_CHANGING_TO_IN_REVIEW_STAGE',
  ESTIMATION_STAGE_MUST_BE_IN_CREATION_OR_IN_REVIEW_WHEN_CHANGING_TO_IN_PROCESS_STAGE = 'ESTIMATION_STAGE_MUST_BE_IN_CREATION_OR_IN_REVIEW_WHEN_CHANGING_TO_IN_PROCESS_STAGE',
  USER_NOT_REVIEWER = 'USER_NOT_REVIEWER',
  CALCULATION_FORMULA_MUST_BE_SET_FOR_METHODOLOGY = 'CALCULATION_FORMULA_MUST_BE_SET_FOR_METHODOLOGY',
  METHODOLOGY_MUST_HAVE_AT_LEAST_ONE_PARAMETER = 'METHODOLOGY_MUST_HAVE_AT_LEAST_ONE_PARAMETER',
  CANNOT_DELETE_METHODOLOGY_IN_USE = 'CANNOT_DELETE_METHODOLOGY_IN_USE',
  ESTIMATION_ITEM_BASED_ON_MODEL_CANNOT_HAVE_THIS_PARENT = 'ESTIMATION_ITEM_BASED_ON_MODEL_CANNOT_HAVE_THIS_PARENT',
  WRONG_ESTIMATION_ITEMS_PARAMETERS_COUNT = 'WRONG_ESTIMATION_ITEMS_PARAMETERS_COUNT',
  WRONG_CALCULATION_METHODOLOGY_FORMULA = 'WRONG_CALCULATION_METHODOLOGY_FORMULA',
  METHODOLOGY_FORMULA_HAS_MISSING_PARAMETERS = 'METHODOLOGY_FORMULA_HAS_MISSING_PARAMETERS',
  METHODOLOGY_FORMULA_SYNTAX_ERROR = 'METHODOLOGY_FORMULA_SYNTAX_ERROR',
  METHODOLOGY_FORMULA_CONTAINS_SUM_ITEMS_EXCEPT = 'METHODOLOGY_FORMULA_CONTAINS_SUM_ITEMS_EXCEPT',
  METHODOLOGY_FORMULA_CONTAINS_ITEM_REFERENCES = 'METHODOLOGY_FORMULA_CONTAINS_ITEM_REFERENCES',
  SUM_ITEMS_EXCEPT_ARGUMENTS_MUST_BE_QUOTED = 'SUM_ITEMS_EXCEPT_ARGUMENTS_MUST_BE_QUOTED',
  AI_INTEGRATION_UNEXPECTED_FINISH_REASON = 'AI_INTEGRATION_UNEXPECTED_FINISH_REASON',
  AI_INTEGRATION_NO_CONTENT = 'AI_INTEGRATION_NO_CONTENT',
  WRONG_RESOURCES_FOR_ESTIMATION_ITEM = 'WRONG_RESOURCES_FOR_ESTIMATION_ITEM',
  WRONG_COSTS_FOR_ESTIMATION_ITEM = 'WRONG_COSTS_FOR_ESTIMATION_ITEM',
  WRONG_RESOURCE_TYPE_COSTS_FOR_ESTIMATION = 'WRONG_RESOURCE_TYPE_COSTS_FOR_ESTIMATION',
  CANNOT_DEFINE_COSTS_WHEN_THERE_ARE_NO_RESOURCE_TYPES_DEFINED = 'CANNOT_DEFINE_COSTS_WHEN_THERE_ARE_NO_RESOURCE_TYPES_DEFINED',
  ESTIMATION_ITEM_FOR_ESTIMATION_MODEL_ITEM_MUST_HAVE_SAME_GROUP_AS_THE_MODEL_ITEM = 'ESTIMATION_ITEM_FOR_ESTIMATION_MODEL_ITEM_MUST_HAVE_SAME_GROUP_AS_THE_MODEL_ITEM',
  WRONG_ESTIMATION_MODEL_GROUP_ID = 'WRONG_ESTIMATION_MODEL_GROUP_ID',
  UNAUTHORIZED_USER_ACCESS = 'UNAUTHORIZED_USER_ACCESS',
  ESTIMATION_MODEL_ITEMS_CANNOT_HAVE_SAME_COMBINATION_OF_PARENT_ID_ORDER_AND_PURPOSE = 'ESTIMATION_MODEL_ITEMS_CANNOT_HAVE_SAME_COMBINATION_OF_PARENT_ID_ORDER_AND_PURPOSE',
  ESTIMATION_MODEL_ITEMS_CANNOT_HAVE_SAME_REF_KEY = 'ESTIMATION_MODEL_ITEMS_CANNOT_HAVE_SAME_REF_KEY',
  ESTIMATION_MODEL_ITEMS_CANNOT_HAVE_SAME_CALCULATION_REF = 'ESTIMATION_MODEL_ITEMS_CANNOT_HAVE_SAME_CALCULATION_REF',
  ESTIMATION_MODEL_WITH_SAME_PROJECT_TYPE_BUT_DIFFERENT_REF_KEY_EXISTS = 'ESTIMATION_MODEL_WITH_SAME_PROJECT_TYPE_BUT_DIFFERENT_REF_KEY_EXISTS',
  ESTIMATION_MUST_BE_APPROVED_WHEN_CREATING_NEW_VERSION = 'ESTIMATION_MUST_BE_APPROVED_WHEN_CREATING_NEW_VERSION',
  CANNOT_UPDATE_ESTIMATION_WHEN_STAGE_IS_IN_REVIEW_OR_APPROVED = 'CANNOT_UPDATE_ESTIMATION_WHEN_STAGE_IS_IN_REVIEW_OR_APPROVED',
  CANNOT_UPDATE_ESTIMATION_ADDITIONAL_FIELDS_WHEN_ESTIMATION_STAGE_IS_IN_REVIEW_OR_APPROVED = 'CANNOT_UPDATE_ESTIMATION_ADDITIONAL_FIELDS_WHEN_ESTIMATION_STAGE_IS_IN_REVIEW_OR_APPROVED',
  CANNOT_UPSERT_ESTIMATION_COSTS_WHEN_ESTIMATION_STAGE_IS_IN_REVIEW_OR_APPROVED = 'CANNOT_UPSERT_ESTIMATION_COSTS_WHEN_ESTIMATION_STAGE_IS_IN_REVIEW_OR_APPROVED',
  CANNOT_CREATE_ESTIMATION_ITEM_WHEN_ESTIMATION_STAGE_IS_IN_REVIEW_OR_APPROVED = 'CANNOT_CREATE_ESTIMATION_ITEM_WHEN_ESTIMATION_STAGE_IS_IN_REVIEW_OR_APPROVED',
  CANNOT_UPSERT_ESTIMATION_ITEMS_WHEN_ESTIMATION_STAGE_IS_IN_REVIEW_OR_APPROVED = 'CANNOT_UPSERT_ESTIMATION_ITEMS_WHEN_ESTIMATION_STAGE_IS_IN_REVIEW_OR_APPROVED',
  CANNOT_UPDATE_ESTIMATION_ITEM_WHEN_ESTIMATION_STAGE_IS_IN_REVIEW_OR_APPROVED = 'CANNOT_UPDATE_ESTIMATION_ITEM_WHEN_ESTIMATION_STAGE_IS_IN_REVIEW_OR_APPROVED',
  CANNOT_DELETE_ESTIMATION_ITEM_WHEN_ESTIMATION_STAGE_IS_IN_REVIEW_OR_APPROVED = 'CANNOT_DELETE_ESTIMATION_ITEM_WHEN_ESTIMATION_STAGE_IS_IN_REVIEW_OR_APPROVED',
  CANNOT_CREATE_ESTIMATION_ITEM_ASSUMPTION_WHEN_ESTIMATION_STAGE_IS_IN_REVIEW_OR_APPROVED = 'CANNOT_CREATE_ESTIMATION_ITEM_ASSUMPTION_WHEN_ESTIMATION_STAGE_IS_IN_REVIEW_OR_APPROVED',
  CANNOT_UPDATE_ESTIMATION_ITEM_ASSUMPTION_WHEN_ESTIMATION_STAGE_IS_IN_REVIEW_OR_APPROVED = 'CANNOT_UPDATE_ESTIMATION_ITEM_ASSUMPTION_WHEN_ESTIMATION_STAGE_IS_IN_REVIEW_OR_APPROVED',
  CANNOT_DELETE_ESTIMATION_ITEM_ASSUMPTION_WHEN_ESTIMATION_STAGE_IS_IN_REVIEW_OR_APPROVED = 'CANNOT_DELETE_ESTIMATION_ITEM_ASSUMPTION_WHEN_ESTIMATION_STAGE_IS_IN_REVIEW_OR_APPROVED',
  CANNOT_UPSERT_ESTIMATION_ITEM_COSTS_WHEN_ESTIMATION_STAGE_IS_IN_REVIEW_OR_APPROVED = 'CANNOT_UPSERT_ESTIMATION_ITEM_COSTS_WHEN_ESTIMATION_STAGE_IS_IN_REVIEW_OR_APPROVED',
  CANNOT_UPSERT_ESTIMATION_ITEM_RESOURCES_WHEN_ESTIMATION_STAGE_IS_IN_REVIEW_OR_APPROVED = 'CANNOT_UPSERT_ESTIMATION_ITEM_RESOURCES_WHEN_ESTIMATION_STAGE_IS_IN_REVIEW_OR_APPROVED',
  CANNOT_DELETE_ESTIMATION_ITEM_WITH_ESTIMATION_MODEL_ITEM = 'CANNOT_DELETE_ESTIMATION_ITEM_WITH_ESTIMATION_MODEL_ITEM',
  CALCULATION_FORMULA_MUST_BE_PROVIDED_WHEN_HAVING_MULTIPLE_PARAMETERS = 'CALCULATION_FORMULA_MUST_BE_PROVIDED_WHEN_HAVING_MULTIPLE_PARAMETERS',
  GRAPH_API_EMPTY_USER_RESULT = 'GRAPH_API_EMPTY_USER_RESULT',
  CANNOT_PARSE_GRAPH_API_USER_ID = 'CANNOT_PARSE_GRAPH_API_USER_ID',
  CANNOT_CHANGE_ESTIMATION_ITEM_METHODOLOGY_ON_CHILD_ITEM = 'CANNOT_CHANGE_ESTIMATION_ITEM_METHODOLOGY_ON_CHILD_ITEM',
  CANNOT_CREATE_INITIAL_ESTIMATION_ITEMS_WHEN_ANY_ITEMS_ALREADY_EXIST = 'CANNOT_CREATE_INITIAL_ESTIMATION_ITEMS_WHEN_ANY_ITEMS_ALREADY_EXIST',
  TENANT_NOT_AVAILABLE = 'TENANT_NOT_AVAILABLE',
  ESTIMATION_ITEM_PARAMETER_VALUES_COUNT_MISMATCH = 'ESTIMATION_ITEM_PARAMETER_VALUES_COUNT_MISMATCH',
  ESTIMATION_ITEM_PARAMETER_CREATION_FAILED = 'ESTIMATION_ITEM_PARAMETER_CREATION_FAILED',
  PUBLISHED_ESTIMATION_MODEL_CANNOT_BE_UNPUBLISHED = 'PUBLISHED_ESTIMATION_MODEL_CANNOT_BE_UNPUBLISHED',
  DUPLICATE_METHODOLOGY_ID_IN_ESTIMATION_MODEL = 'DUPLICATE_METHODOLOGY_ID_IN_ESTIMATION_MODEL',
  ESTIMATION_MODEL_UNIT_MISMATCH = 'ESTIMATION_MODEL_UNIT_MISMATCH',
  DUPLICATE_ESTIMATION_UNIT_IN_ESTIMATION_MODEL = 'DUPLICATE_ESTIMATION_UNIT_IN_ESTIMATION_MODEL',
  ESTIMATION_MODEL_ADDITIONAL_FIELD_TYPE_MUST_BE_SELECTABLE = 'ESTIMATION_MODEL_ADDITIONAL_FIELD_TYPE_MUST_BE_SELECTABLE',
  ESTIMATION_MODEL_ADDITIONAL_FIELD_OPTIONS_MUST_NOT_BE_EMPTY = 'ESTIMATION_MODEL_ADDITIONAL_FIELD_OPTIONS_MUST_NOT_BE_EMPTY',
  ESTIMATION_MODEL_ADDITIONAL_FIELD_OPTION_MUST_NOT_CONTAIN_PIPE = 'ESTIMATION_MODEL_ADDITIONAL_FIELD_OPTION_MUST_NOT_CONTAIN_PIPE',
  SELF_REFERENCING_PARENT_ERROR = 'SELF_REFERENCING_PARENT_ERROR',
  CALCULATION_FORMULA_MISSING = 'CALCULATION_FORMULA_MISSING',
  INVALID_CALCULATION_REFERENCE = 'INVALID_CALCULATION_REFERENCE',
  FILTER_COMBINATION_IS_NOT_SUPPORTED = 'FILTER_COMBINATION_IS_NOT_SUPPORTED',
  PARENT_AND_CHILD_COMMENT_DISCRIMINATOR_TYPE_MISMATCH = 'PARENT_AND_CHILD_COMMENT_DISCRIMINATOR_TYPE_MISMATCH',
  ESTIMATION_MODEL_ITEM_HAS_RECURSIVE_FORMULA_REFERENCE = 'ESTIMATION_MODEL_ITEM_HAS_RECURSIVE_FORMULA_REFERENCE',
  ESTIMATION_MODEL_ITEM_HAS_WRONG_FORMULA_REFERENCE = 'ESTIMATION_MODEL_ITEM_HAS_WRONG_FORMULA_REFERENCE',
  ESTIMATION_MODEL_ITEM_HAS_MISSING_FORMULA_PARAMETERS = 'ESTIMATION_MODEL_ITEM_HAS_MISSING_FORMULA_PARAMETERS',
  ESTIMATION_MODEL_ITEM_REFERENCES_NON_EXISTING_ITEM = 'ESTIMATION_MODEL_ITEM_REFERENCES_NON_EXISTING_ITEM',
  CANNOT_SET_PARAMETERS_ON_ITEM_WITH_COST_PURPOSE = 'CANNOT_SET_PARAMETERS_ON_ITEM_WITH_COST_PURPOSE',
  ESTIMATION_ITEM_PURPOSE_MUST_MATCH_ITS_ESTIMATION_MODEL_ITEM_PURPOSE = 'ESTIMATION_ITEM_PURPOSE_MUST_MATCH_ITS_ESTIMATION_MODEL_ITEM_PURPOSE',
  CANNOT_SET_METHODOLOGY_ON_ITEM_WITH_COST_PURPOSE = 'CANNOT_SET_METHODOLOGY_ON_ITEM_WITH_COST_PURPOSE',
  ESTIMATION_ITEM_OF_COST_PURPOSE_CANNOT_HAVE_CALCULATED_RESULT = 'ESTIMATION_ITEM_OF_COST_PURPOSE_CANNOT_HAVE_CALCULATED_RESULT',
  PARENT_ESTIMATION_ITEM_PURPOSE_MUST_MATCH = 'PARENT_ESTIMATION_ITEM_PURPOSE_MUST_MATCH',
  ESTIMATION_MODEL_ITEM_PARENT_PURPOSE_MUST_MATCH = 'ESTIMATION_MODEL_ITEM_PARENT_PURPOSE_MUST_MATCH',
  CANNOT_SET_METHODOLOGY_ON_ESTIMATION_MODEL_ITEM_WITH_COST_PURPOSE = 'CANNOT_SET_METHODOLOGY_ON_ESTIMATION_MODEL_ITEM_WITH_COST_PURPOSE',
  ESTIMATION_MODEL_ITEM_WITH_COST_PURPOSE_CANNOT_HAVE_CALCULATION_FORMULA = 'ESTIMATION_MODEL_ITEM_WITH_COST_PURPOSE_CANNOT_HAVE_CALCULATION_FORMULA',
  ESTIMATION_MODEL_ITEM_WITH_COST_PURPOSE_CANNOT_HAVE_PARAMETERS = 'ESTIMATION_MODEL_ITEM_WITH_COST_PURPOSE_CANNOT_HAVE_PARAMETERS',
  CANNOT_ASSIGN_RESOURCE_TO_ESTIMATION_ITEM_WITH_COST_PURPOSE = 'CANNOT_ASSIGN_RESOURCE_TO_ESTIMATION_ITEM_WITH_COST_PURPOSE',
  DECIMAL_VALUE_TOO_MANY_DIGITS = 'DECIMAL_VALUE_TOO_MANY_DIGITS',
  DECIMAL_VALUE_TOO_MANY_DECIMAL_DIGITS = 'DECIMAL_VALUE_TOO_MANY_DECIMAL_DIGITS',
  CALCULATED_ESTIMATION_MODEL_ITEM_CANNOT_HAVE_PARAMETER_WITH_NULL_VALUE = 'CALCULATED_ESTIMATION_MODEL_ITEM_CANNOT_HAVE_PARAMETER_WITH_NULL_VALUE',
  CANNOT_COMMENT_WHEN_ESTIMATION_IS_NOT_IN_REVIEW = 'CANNOT_COMMENT_WHEN_ESTIMATION_IS_NOT_IN_REVIEW',
  THERE_MUST_BE_EXACTLY_ONE_PLANNING_RESPONSIBLE_FOR_ESTIMATION = 'THERE_MUST_BE_EXACTLY_ONE_PLANNING_RESPONSIBLE_FOR_ESTIMATION',
  CANNOT_DELETE_USER_WHEN_IS_PLANNING_RESPONSIBLE = 'CANNOT_DELETE_USER_WHEN_IS_PLANNING_RESPONSIBLE',
  EVERY_PHASE_LEAD_MUST_BE_ASSIGNED_AS_CONTRIBUTOR_OR_PLANNING_RESPONSIBLE_TO_ESTIMATION = 'EVERY_PHASE_LEAD_MUST_BE_ASSIGNED_AS_CONTRIBUTOR_OR_PLANNING_RESPONSIBLE_TO_ESTIMATION',
  AI_SERVICE_ERROR = 'AI_SERVICE_ERROR',
  UNSUPPORTED_COMMENT_TYPE = 'UNSUPPORTED_COMMENT_TYPE',
  UPLOAD_FILE_EMPTY = 'UPLOAD_FILE_EMPTY',
  UPLOAD_FILE_TOO_LARGE = 'UPLOAD_FILE_TOO_LARGE',
  UPLOAD_MIME_TYPE_NOT_ALLOWED = 'UPLOAD_MIME_TYPE_NOT_ALLOWED',
  ESTIMATION_MODEL_NO_PUBLISHED_VERSION_TO_EXPORT = 'ESTIMATION_MODEL_NO_PUBLISHED_VERSION_TO_EXPORT',
  ESTIMATION_MODEL_IMPORT_NAME_CONFLICT = 'ESTIMATION_MODEL_IMPORT_NAME_CONFLICT',
  ESTIMATION_MODEL_IMPORT_INCOMPATIBLE_SCHEMA_VERSION = 'ESTIMATION_MODEL_IMPORT_INCOMPATIBLE_SCHEMA_VERSION',
  ESTIMATION_MODEL_IMPORT_PROJECT_TYPE_UNRESOLVED = 'ESTIMATION_MODEL_IMPORT_PROJECT_TYPE_UNRESOLVED',
  ESTIMATOR_VERSION_INCOMPATIBLE = 'ESTIMATOR_VERSION_INCOMPATIBLE',
  USER_PROVISIONING_MISSING_EMAIL_CLAIM = 'USER_PROVISIONING_MISSING_EMAIL_CLAIM',
  AI_ADVISORY_NO_STRUCTURED_DATA = 'AI_ADVISORY_NO_STRUCTURED_DATA',
  AI_ADVISORY_EMPTY_STRUCTURED_DATA = 'AI_ADVISORY_EMPTY_STRUCTURED_DATA',
  AI_ADVISORY_SELECTED_WBS_IDS_INVALID = 'AI_ADVISORY_SELECTED_WBS_IDS_INVALID',
  AI_ADVISORY_TENANT_NOT_SEEDED = 'AI_ADVISORY_TENANT_NOT_SEEDED',
  ESTIMATION_MODEL_AI_TEMPLATE_MISSING_REQUIRED_PLACEHOLDERS = 'ESTIMATION_MODEL_AI_TEMPLATE_MISSING_REQUIRED_PLACEHOLDERS',
  ESTIMATION_MODEL_CANNOT_BE_PUBLISHED_WITH_NO_ITEMS = 'ESTIMATION_MODEL_CANNOT_BE_PUBLISHED_WITH_NO_ITEMS',
  ESTIMATION_MODEL_CANNOT_BE_PUBLISHED_WITHOUT_NAME = 'ESTIMATION_MODEL_CANNOT_BE_PUBLISHED_WITHOUT_NAME',
  ORPHANED_SUB_PHASE_ITEM_NOT_ALLOWED = 'ORPHANED_SUB_PHASE_ITEM_NOT_ALLOWED',
}

export enum ApiCommentType {
  ESTIMATION = 'ESTIMATION',
  ESTIMATION_ITEM = 'ESTIMATION_ITEM',
}

export enum ApiCommentContextType {
  ESTIMATION = 'ESTIMATION',
  RESOURCING = 'RESOURCING',
  COSTING = 'COSTING',
}

export interface AdminLocalizationRequest {
  /**
   * @minLength 1
   * @maxLength 10
   */
  cultureName: string;
  /** @format uuid */
  refKey: string;
  /**
   * @minLength 1
   * @maxLength 4000
   */
  value: string;
}

export interface AdminLocalizationResponse {
  cultureName: string;
  /** @format uuid */
  refKey: string;
  value: string;
}

export interface BackendLocalizationResponse {
  key: string;
  description: string;
  defaultValue: string;
  value?: string | null;
}

export interface BasicEstimationsPerProjectsResponse {
  project: ProjectResponse;
  estimation: EstimationBasicResponse;
  planningResponsible: UserResponse;
  creator?: UserResponse;
  userCanEdit: boolean;
  userCanDelete: boolean;
}

export interface BasicEstimationsPerProjectsResponsePaginatedResponse {
  /** @format int32 */
  totalCount: number;
  items: BasicEstimationsPerProjectsResponse[];
}

export interface ChatHistoryItem {
  /** @format uuid */
  messageId: string;
  /** @format uuid */
  conversationId: string;
  role: string;
  content: string;
  /** @format date-time */
  createdAt: string;
  /** @format int32 */
  tokenCount: number;
  /** @format date-span */
  processingTime?: string | null;
}

export interface CommentResponse {
  /** @format uuid */
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format uuid */
  createdById?: string | null;
  /** @format uuid */
  updatedById?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
  /** @format uuid */
  parentId?: string | null;
  text: string;
  /** @format uuid */
  userId: string;
  contextType: ApiCommentContextType;
}

export interface ConversationFolderItem {
  /** @format uuid */
  folderId: string;
  name: string;
  /** @format date-time */
  createdAt: string;
  /** @format int32 */
  conversationCount: number;
}

export interface ConversationItem {
  /** @format uuid */
  conversationId: string;
  title: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  lastMessageAt?: string | null;
  /**
   * EWM-521: optional sidebar folder grouping. Null = unfoldered (top-level).
   * @format uuid
   */
  folderId?: string | null;
  /** EWM-534: false when the conversation was shared with the current user by someone else. */
  isOwner: boolean;
}

export interface ConvertAdvisoryToEstimationRequest {
  /**
   * Advisory WBS ids the user selected to import. Must be non-empty; the handler
   * throws EstiWorld.Core.ErrorCode.AiAdvisoryEmptyStructuredData otherwise.
   */
  selectedWbsIds: string[];
  /** Advisory assumption ids the user selected to import. May be empty. */
  selectedAssumptionIds: string[];
  /**
   * Project name override (defaults to advisor's projectName).
   * @minLength 1
   * @maxLength 255
   */
  projectName: string;
  /**
   * Project description override (defaults to advisor's projectDescription).
   * @minLength 0
   * @maxLength 4000
   */
  projectDescription?: string | null;
  /**
   * Optional permalink the user wants stored on the new Estimation's
   * AiAdvisoryDocumentLink field. The FE prefills it with the convert
   * source URL but allows editing.
   * @format uri
   * @minLength 0
   * @maxLength 2048
   */
  aiAdvisoryDocumentLink?: string | null;
}

export interface ConvertAdvisoryToEstimationResponse {
  /** @format uuid */
  estimationId: string;
  /** @format uuid */
  projectId: string;
  projectName: string;
  /** @format int32 */
  itemCount: number;
  /** @format int32 */
  assumptionCount: number;
}

export interface CostTypeGroupResponse {
  /** @format uuid */
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format uuid */
  createdById?: string | null;
  /** @format uuid */
  updatedById?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
  name: string;
  description?: string | null;
  /** @format uuid */
  nameRefKey: string;
  /** @format uuid */
  descriptionRefKey?: string | null;
  localizations: AdminLocalizationResponse[];
  /** @format int32 */
  order: number;
  costTypes: CostTypeResponse[];
}

export interface CostTypeResponse {
  /** @format uuid */
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format uuid */
  createdById?: string | null;
  /** @format uuid */
  updatedById?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
  name: string;
  description?: string | null;
  /** @format uuid */
  nameRefKey: string;
  /** @format uuid */
  descriptionRefKey?: string | null;
  localizations: AdminLocalizationResponse[];
  /** @format int32 */
  order: number;
}

export interface CreateCommentRequest {
  /**
   * @minLength 1
   * @maxLength 1000
   */
  text: string;
  commentType: ApiCommentType;
  contextType: ApiCommentContextType;
  /** @format uuid */
  parentId?: string | null;
  /** @format uuid */
  entityId: string;
}

export interface CreateConversationFolderRequest {
  /**
   * @minLength 1
   * @maxLength 60
   */
  name: string;
}

export interface CreateConversationFolderResponse {
  /** @format uuid */
  folderId: string;
  name: string;
  /** @format date-time */
  createdAt: string;
}

export interface CreateConversationRequest {
  /**
   * @minLength 1
   * @maxLength 500
   */
  title: string;
}

export interface CreateConversationResponse {
  /** @format uuid */
  conversationId: string;
  title: string;
  /** @format date-time */
  createdAt: string;
}

export interface CreateCostTypeGroupRequest {
  /**
   * NameRefKey Guid value is either provided in case of an update or generated by FE for new records
   * @format uuid
   */
  nameRefKey: string;
  /**
   * DescriptionRefKey is optional and the Guid value is either provided in case of an update or generated by FE for new records
   * @format uuid
   */
  descriptionRefKey?: string | null;
  localizations: AdminLocalizationRequest[];
  /** @format int32 */
  order: number;
  costTypes: CreateCostTypeRequest[];
}

export interface CreateCostTypeRequest {
  /**
   * NameRefKey Guid value is either provided in case of an update or generated by FE for new records
   * @format uuid
   */
  nameRefKey: string;
  /**
   * DescriptionRefKey is optional and the Guid value is either provided in case of an update or generated by FE for new records
   * @format uuid
   */
  descriptionRefKey?: string | null;
  localizations: AdminLocalizationRequest[];
  id: TempGuid;
  /** @format int32 */
  order: number;
}

export interface CreateEstimationAdditionalFieldDefinitionRequest {
  /**
   * NameRefKey Guid value is either provided in case of an update or generated by FE for new records
   * @format uuid
   */
  nameRefKey: string;
  /**
   * DescriptionRefKey is optional and the Guid value is either provided in case of an update or generated by FE for new records
   * @format uuid
   */
  descriptionRefKey?: string | null;
  localizations: AdminLocalizationRequest[];
  /** @format int32 */
  order: number;
  additionalFieldType: ApiEstimationAdditionalFieldType;
  /**
   * Used with EstiWorld.Api.Models.Common.CreateEstimationAdditionalFieldDefinitionRequest.AdditionalFieldType set to EstiWorld.Api.Models.Common.Enums.ApiEstimationAdditionalFieldType.Selectable
   * @format uuid
   */
  selectableOptionsRefKey?: string | null;
  /** @format uuid */
  guidedModeQuestionRefKey?: string | null;
  isRequired: boolean;
}

export interface CreateEstimationItemAssumptionRequest {
  /** @format uuid */
  estimationModelAssumptionCategoryId?: string | null;
  /**
   * @minLength 1
   * @maxLength 1000
   */
  description: string;
  isValid: boolean;
}

export interface CreateEstimationItemRequest {
  /**
   * @minLength 1
   * @maxLength 300
   */
  name: string;
  /** @maxLength 1000 */
  description?: string | null;
  /**
   * Useful in guided mode when we don't care about child estimation items values yet,
   * and we want to calculate the estimated value from this estimation item
   * and not as a sum of estimated values of all its children.
   */
  isParentBasedCalculation: boolean;
  status: ApiEstimationItemStatus;
  /**
   * Must be set in case EstiWorld.Api.Models.EstimationItem.CreateEstimationItemRequest.Status is set to EstiWorld.Api.Models.Common.Enums.ApiEstimationItemStatus.Omitted, otherwise null.
   * @maxLength 1000
   */
  omitReason?: string | null;
  /** @format uuid */
  parentId?: string | null;
  unit: EstimationUnit;
  /** @format uuid */
  estimationModelItemId?: string | null;
  /**
   * Must be selected on FE if EstimationModelItem has no parameters and is not calculated (only in that case).
   * When changed, ParameterValues must be recreated based on the parameters of the selected methodology.
   * @format uuid
   */
  methodologyId?: string | null;
  /**
   * User ID
   * @format uuid
   */
  phaseLeadId?: string | null;
  /** @format uuid */
  currencyId?: string | null;
  /**
   * EWM-154 — optional phase deadline that drives the phase-deadline-approaching notifications.
   * @format date-time
   */
  dueDate?: string | null;
  /** Parameter values ordered based on parameters of corresponding estimation model item resp. parameters of methodology */
  parameterValues: (number | null)[];
  /**
   * One of EstimationModel Groups' IDs.
   * When estimation item has estimation model item the value must be always set to
   * corresponding estimation model item group ID.
   * @format uuid
   */
  estimationModelGroupId: string;
  purpose: ApiEstimationItemPurpose;
}

export interface CreateEstimationModelAssumptionCategoryRequest {
  /**
   * NameRefKey Guid value is either provided in case of an update or generated by FE for new records
   * @format uuid
   */
  nameRefKey: string;
  /**
   * DescriptionRefKey is optional and the Guid value is either provided in case of an update or generated by FE for new records
   * @format uuid
   */
  descriptionRefKey?: string | null;
  localizations: AdminLocalizationRequest[];
  /** @format int32 */
  order: number;
}

export interface CreateEstimationModelItemGroupRequest {
  /**
   * NameRefKey Guid value is either provided in case of an update or generated by FE for new records
   * @format uuid
   */
  nameRefKey: string;
  /**
   * DescriptionRefKey is optional and the Guid value is either provided in case of an update or generated by FE for new records
   * @format uuid
   */
  descriptionRefKey?: string | null;
  localizations: AdminLocalizationRequest[];
  id: TempGuid;
  /** @format int32 */
  order: number;
  forbidCustomEstimationItem: boolean;
  level: EstimationModelItemGroupLevel;
}

export interface CreateEstimationModelItemParameterRequest {
  /**
   * LabelRefKey Guid value is either provided in case of an update or generated by FE for new records
   * @format uuid
   */
  labelRefKey: string;
  localizations: AdminLocalizationRequest[];
  /** @format int32 */
  order: number;
  /**
   * @minLength 1
   * @maxLength 20
   */
  calculationRef: string;
  /** @format double */
  defaultValue?: number | null;
}

export interface CreateEstimationModelItemRequest {
  /**
   * NameRefKey Guid value is either provided in case of an update or generated by FE for new records
   * @format uuid
   */
  nameRefKey: string;
  /**
   * DescriptionRefKey is optional and the Guid value is either provided in case of an update or generated by FE for new records
   * @format uuid
   */
  descriptionRefKey?: string | null;
  localizations: AdminLocalizationRequest[];
  id: TempGuid;
  /** @format int32 */
  order: number;
  groupId: TempGuid;
  parentId?: TempGuid;
  /** @format uuid */
  defaultMethodologyId?: string | null;
  calculationFormula?: string | null;
  isRequired: boolean;
  isPreselected: boolean;
  isSuggested: boolean;
  /** Indicates how an estimation model item's value is determined. */
  isCalculated: ApiIsCalculatedMode;
  /** @format uuid */
  refKey?: string | null;
  /**
   * Used in formula of another EstimationModelItem with IsCalculated == Formula.
   * @pattern ^[a-zA-Z0-9_-]+$
   */
  calculationRef?: string | null;
  purpose: ApiEstimationItemPurpose;
  parameters: CreateEstimationModelItemParameterRequest[];
}

export interface CreateEstimationModelRequest {
  /**
   * NameRefKey Guid value is either provided in case of an update or generated by FE for new records
   * @format uuid
   */
  nameRefKey: string;
  /**
   * DescriptionRefKey is optional and the Guid value is either provided in case of an update or generated by FE for new records
   * @format uuid
   */
  descriptionRefKey?: string | null;
  localizations: AdminLocalizationRequest[];
  /**
   * Identifies same group of models. If empty, a new model will be created.
   * If set, there must be another model with same EstiWorld.Api.Models.EstimationModel.CreateEstimationModelRequest.RefKey. The latest version
   * of that existing model will be deleted if the model is unpublished.
   * @format uuid
   */
  refKey?: string | null;
  /** @format uuid */
  projectTypeId: string;
  /** @format uuid */
  aiRequestTemplateRefKey?: string | null;
  isAiEnabled: boolean;
  additionalFields: CreateEstimationAdditionalFieldDefinitionRequest[];
  assumptionCategories: CreateEstimationModelAssumptionCategoryRequest[];
  items: CreateEstimationModelItemRequest[];
  estimationModelUnits: EstimationUnit[];
  resourceTypes: CreateResourceTypeRequest[];
  resourceTypeGroups: CreateResourceTypeGroupRequest[];
  costTypes: CreateCostTypeRequest[];
  costTypeGroups: CreateCostTypeGroupRequest[];
  methodologyIds: string[];
  itemGroups: CreateEstimationModelItemGroupRequest[];
  currencyIds: string[];
}

export interface CreateEstimationRequest {
  /**
   * @minLength 1
   * @maxLength 128
   */
  versionName: string;
  /**
   * @minLength 1
   * @maxLength 10
   */
  cultureName: string;
  unit: EstimationUnit;
  /** @format uuid */
  estimationModelId: string;
  /** @format uuid */
  methodologyId: string;
  /** @format uuid */
  planningResponsibleId: string;
  projectDescription?: string | null;
}

export interface CreateEstimationVersionRequest {
  /**
   * @minLength 1
   * @maxLength 128
   */
  versionName: string;
}

export interface CreateProjectRequest {
  /**
   * @minLength 1
   * @maxLength 100
   */
  name: string;
  /** @format uuid */
  projectTypeId: string;
}

export interface CreateProjectWithEstimationRequest {
  project: CreateProjectRequest;
  estimation: CreateEstimationRequest;
}

export interface CreateResourceTypeGroupRequest {
  /**
   * NameRefKey Guid value is either provided in case of an update or generated by FE for new records
   * @format uuid
   */
  nameRefKey: string;
  /**
   * DescriptionRefKey is optional and the Guid value is either provided in case of an update or generated by FE for new records
   * @format uuid
   */
  descriptionRefKey?: string | null;
  localizations: AdminLocalizationRequest[];
  /** @format int32 */
  order: number;
  resourceTypes: CreateResourceTypeRequest[];
}

export interface CreateResourceTypeRequest {
  /**
   * NameRefKey Guid value is either provided in case of an update or generated by FE for new records
   * @format uuid
   */
  nameRefKey: string;
  /**
   * DescriptionRefKey is optional and the Guid value is either provided in case of an update or generated by FE for new records
   * @format uuid
   */
  descriptionRefKey?: string | null;
  localizations: AdminLocalizationRequest[];
  /** @format int32 */
  order: number;
  costTypeId: TempGuid;
  /** @format double */
  resourceCost?: number | null;
  userModifiable?: boolean | null;
}

export interface CreateUserRequest {
  /**
   * @minLength 1
   * @maxLength 100
   */
  forename: string;
  /**
   * @minLength 1
   * @maxLength 100
   */
  surname: string;
  /**
   * @minLength 1
   * @maxLength 254
   */
  email: string;
  /**
   * @minLength 1
   * @maxLength 10
   */
  cultureName: string;
  isActive: boolean;
  roleIds: string[];
}

export interface CurrencyResponse {
  /** @format uuid */
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format uuid */
  createdById?: string | null;
  /** @format uuid */
  updatedById?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
  name: string;
  code: string;
  symbol: string;
}

export interface EstimationAdditionalFieldDefinitionResponse {
  /** @format uuid */
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format uuid */
  createdById?: string | null;
  /** @format uuid */
  updatedById?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
  name: string;
  description?: string | null;
  /** @format uuid */
  nameRefKey: string;
  /** @format uuid */
  descriptionRefKey?: string | null;
  localizations: AdminLocalizationResponse[];
  /** @format int32 */
  order: number;
  isRequired: boolean;
  additionalFieldType: ApiEstimationAdditionalFieldType;
  /** Used with EstiWorld.Api.Models.Common.EstimationAdditionalFieldDefinitionResponse.AdditionalFieldType set to EstiWorld.Api.Models.Common.Enums.ApiEstimationAdditionalFieldType.Selectable */
  selectableOptions: string[];
  /** @format uuid */
  selectableOptionsRefKey?: string | null;
  guidedModeQuestion?: string | null;
  /** @format uuid */
  guidedModeQuestionRefKey?: string | null;
}

export interface EstimationAdditionalFieldResponse {
  /** @format uuid */
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format uuid */
  createdById?: string | null;
  /** @format uuid */
  updatedById?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
  value: string | null;
  /** @format uuid */
  estimationModelAdditionalFieldDefinitionId: string;
  type: ApiEstimationAdditionalFieldType;
}

export interface EstimationAiAssistedReviewRequest {
  /**
   * @format int32
   * @min 300
   * @max 10000
   */
  maxWordsCount: number;
  /**
   * @minLength 1
   * @maxLength 10
   */
  cultureName: string;
}

export interface EstimationAiReviewResponse {
  /** @format uuid */
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format uuid */
  createdById?: string | null;
  /** @format uuid */
  updatedById?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
  review: string;
}

export interface EstimationBasicResponse {
  /** @format uuid */
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format uuid */
  createdById?: string | null;
  /** @format uuid */
  updatedById?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
  versionName: string;
  cultureName: string;
  /** @format int32 */
  versionNumber: number;
  /** @format uuid */
  parentId?: string | null;
  stage: ApiEstimationStage;
  /** @format double */
  calculatedResult: number;
  unit: EstimationUnit;
  /** @format uuid */
  estimationModelId: string;
  /** @format uuid */
  methodologyId: string;
  isCurrent: boolean;
  /** @format uuid */
  planningResponsibleId: string;
}

export interface EstimationCommentResponse {
  /** @format uuid */
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format uuid */
  createdById?: string | null;
  /** @format uuid */
  updatedById?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
  /** @format uuid */
  parentId?: string | null;
  text: string;
  /** @format uuid */
  userId: string;
  contextType: ApiCommentContextType;
  /** @format uuid */
  estimationId?: string | null;
  /** @format uuid */
  estimationItemId?: string | null;
}

export interface EstimationCostResponse {
  /** @format uuid */
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format uuid */
  createdById?: string | null;
  /** @format uuid */
  updatedById?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
  /** @format uuid */
  estimationId: string;
  /** @format uuid */
  currencyId: string;
  resourceTypeCosts: ResourceTypeCostResponse[];
}

export interface EstimationItemAssumptionResponse {
  /** @format uuid */
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format uuid */
  createdById?: string | null;
  /** @format uuid */
  updatedById?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
  /** @format uuid */
  estimationModelAssumptionCategoryId?: string | null;
  description: string;
  isValid: boolean;
  /** @format uuid */
  estimationItemId: string;
  /**
   * EWM-1075: the assumption's key in the AI advisory it was imported from. Null for manually
   * created assumptions and for anything converted before the field existed.
   */
  advisoryAssumptionRef?: string | null;
}

export interface EstimationItemCommentResponse {
  /** @format uuid */
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format uuid */
  createdById?: string | null;
  /** @format uuid */
  updatedById?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
  /** @format uuid */
  parentId?: string | null;
  text: string;
  /** @format uuid */
  userId: string;
  contextType: ApiCommentContextType;
  /** @format uuid */
  estimationItemId: string;
}

export interface EstimationItemCostResponse {
  /** @format uuid */
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format uuid */
  createdById?: string | null;
  /** @format uuid */
  updatedById?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
  /** @format double */
  price: number | null;
  /** @format uuid */
  estimationItemId: string;
  /** @format uuid */
  costTypeId: string;
}

export interface EstimationItemParameterResponse {
  /** @format uuid */
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format uuid */
  createdById?: string | null;
  /** @format uuid */
  updatedById?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
  /** @format int32 */
  order: number;
  /** @format double */
  value?: number | null;
  /** @format uuid */
  methodologyParameterId?: string | null;
  /** @format uuid */
  estimationModelItemParameterId?: string | null;
}

export interface EstimationItemResourceResponse {
  /** @format uuid */
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format uuid */
  createdById?: string | null;
  /** @format uuid */
  updatedById?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
  /** @format double */
  value: number | null;
  /** @format uuid */
  estimationItemId: string;
  /** @format uuid */
  resourceTypeId: string;
}

export interface EstimationItemResponse {
  /** @format uuid */
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format uuid */
  createdById?: string | null;
  /** @format uuid */
  updatedById?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
  name: string;
  description?: string | null;
  /** @format int32 */
  order: number;
  isEnabled: boolean;
  status: ApiEstimationItemStatus;
  omitReason?: string | null;
  /** @format double */
  calculatedResult?: number | null;
  /** @format uuid */
  parentId?: string | null;
  unit: EstimationUnit;
  /** @format uuid */
  estimationModelItemId?: string | null;
  /** @format uuid */
  methodologyId?: string | null;
  /** @format uuid */
  phaseLeadId?: string | null;
  /** @format uuid */
  currencyId?: string | null;
  /** @format date-time */
  dueDate?: string | null;
  isBlocked: boolean;
  /** @format uuid */
  estimationModelGroupId: string;
  isParentBasedCalculation: boolean;
  purpose: ApiEstimationItemPurpose;
  parameters: EstimationItemParameterResponse[];
}

/** EWM-1036: existing estimations bound to any version of one model lineage. */
export interface EstimationModelAffectedEstimationsCountResponse {
  /** @format int32 */
  affectedEstimationsCount: number;
}

export interface EstimationModelAssumptionCategoryResponse {
  /** @format uuid */
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format uuid */
  createdById?: string | null;
  /** @format uuid */
  updatedById?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
  name: string;
  description?: string | null;
  /** @format uuid */
  nameRefKey: string;
  /** @format uuid */
  descriptionRefKey?: string | null;
  localizations: AdminLocalizationResponse[];
  /** @format int32 */
  order: number;
}

export interface EstimationModelBaseResponse {
  /** @format uuid */
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format uuid */
  createdById?: string | null;
  /** @format uuid */
  updatedById?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
  name: string;
  /** @format int32 */
  version: number;
  isPublished: boolean;
  isAiEnabled: boolean;
  /** @format uuid */
  refKey: string;
  /** @format uuid */
  projectTypeId: string;
  isArchived: boolean;
}

export interface EstimationModelItemGroupResponse {
  /** @format uuid */
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format uuid */
  createdById?: string | null;
  /** @format uuid */
  updatedById?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
  name: string;
  description?: string | null;
  /** @format uuid */
  nameRefKey: string;
  /** @format uuid */
  descriptionRefKey?: string | null;
  localizations: AdminLocalizationResponse[];
  /** @format int32 */
  order: number;
  forbidCustomEstimationItem: boolean;
  level: EstimationModelItemGroupLevel;
}

export interface EstimationModelItemParameterResponse {
  /** @format uuid */
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format uuid */
  createdById?: string | null;
  /** @format uuid */
  updatedById?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
  label: string;
  /** @format uuid */
  labelRefKey: string;
  localizations: AdminLocalizationResponse[];
  /** @format int32 */
  order: number;
  calculationRef: string;
  /** @format double */
  defaultValue?: number | null;
}

export interface EstimationModelItemResponse {
  /** @format uuid */
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format uuid */
  createdById?: string | null;
  /** @format uuid */
  updatedById?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
  name: string;
  description?: string | null;
  /** @format uuid */
  nameRefKey: string;
  /** @format uuid */
  descriptionRefKey?: string | null;
  localizations: AdminLocalizationResponse[];
  /** @format int32 */
  order: number;
  group: EstimationModelItemGroupResponse;
  /** @format uuid */
  parentId?: string | null;
  /** @format uuid */
  defaultMethodologyId?: string | null;
  calculationFormula?: string | null;
  calculationRef?: string | null;
  isRequired: boolean;
  isPreselected: boolean;
  isSuggested: boolean;
  /** Indicates how an estimation model item's value is determined. */
  isCalculated: ApiIsCalculatedMode;
  /** @format uuid */
  refKey: string;
  purpose: ApiEstimationItemPurpose;
  parameters: EstimationModelItemParameterResponse[];
}

export interface EstimationModelResponse {
  /** @format uuid */
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format uuid */
  createdById?: string | null;
  /** @format uuid */
  updatedById?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
  name: string;
  description?: string | null;
  /** @format uuid */
  nameRefKey: string;
  /** @format uuid */
  descriptionRefKey?: string | null;
  localizations: AdminLocalizationResponse[];
  /** @format uuid */
  refKey: string;
  /** @format int32 */
  version: number;
  aiRequestTemplate?: string | null;
  /** @format uuid */
  aiRequestTemplateRefKey?: string | null;
  isAiEnabled: boolean;
  isPublished: boolean;
  /** @format uuid */
  projectTypeId: string;
  items: EstimationModelItemResponse[];
  additionalFields: EstimationAdditionalFieldDefinitionResponse[];
  assumptionCategories: EstimationModelAssumptionCategoryResponse[];
  estimationModelUnits: EstimationModelUnitResponse[];
  resourceTypes: ResourceTypeResponse[];
  resourceTypeGroups: ResourceTypeGroupResponse[];
  costTypes: CostTypeResponse[];
  costTypeGroups: CostTypeGroupResponse[];
  methodologyIds: string[];
  itemGroups: EstimationModelItemGroupResponse[];
  currencyIds: string[];
  isArchived: boolean;
  /** @format date-time */
  archivedAt?: string | null;
  /** @format uuid */
  archivedById?: string | null;
  /** @format date-time */
  reactivatedAt?: string | null;
  /** @format uuid */
  reactivatedById?: string | null;
  /**
   * EWM-1036: existing estimations bound to any version of this model lineage - the impact number
   * the archive confirmation dialog shows.
   * @format int32
   */
  affectedEstimationsCount: number;
}

export interface EstimationModelUnitResponse {
  /** @format uuid */
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format uuid */
  createdById?: string | null;
  /** @format uuid */
  updatedById?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
  /** @format uuid */
  estimationModelId: string;
  type: EstimationUnit;
}

export interface EstimationResponse {
  /** @format uuid */
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format uuid */
  createdById?: string | null;
  /** @format uuid */
  updatedById?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
  versionName: string;
  /** @format int32 */
  versionNumber: number;
  cultureName: string;
  isCurrent: boolean;
  stage: ApiEstimationStage;
  unit: EstimationUnit;
  /** @format uuid */
  estimationModelId: string;
  /** @format uuid */
  methodologyId: string;
  /** @format uuid */
  planningResponsibleId: string;
  projectDescription?: string | null;
  aiAdvisoryDocumentLink?: string | null;
  userAssignments: EstimationUserAssignmentResponse[];
  resourceDisplayNames?: Record<string, string>;
}

export interface EstimationUserAssignmentRequest {
  assignmentType: ApiEstimationUserAssignmentType;
  /** @format uuid */
  userId: string;
}

export interface EstimationUserAssignmentResponse {
  /** @format uuid */
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format uuid */
  createdById?: string | null;
  /** @format uuid */
  updatedById?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
  assignmentType: ApiEstimationUserAssignmentType;
  /** @format uuid */
  userId: string;
  /** @format uuid */
  estimationId: string;
}

export interface EstimationUserResponse {
  /** @format uuid */
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format uuid */
  createdById?: string | null;
  /** @format uuid */
  updatedById?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
  forename: string;
  surname: string;
  email: string;
  cultureName: string;
  isActive: boolean;
  roleIds: string[];
  estimationUserAssignmentType: ApiEstimationUserAssignmentType;
}

export interface EstimationUserResponsePaginatedResponse {
  /** @format int32 */
  totalCount: number;
  items: EstimationUserResponse[];
}

export interface ExportConversationRequest {
  /** @format uuid */
  conversationId: string;
  /**
   * @minLength 0
   * @maxLength 20
   */
  format: string;
  includeMetadata: boolean;
  includeTimestamps: boolean;
}

export interface ExportConversationResponse {
  fileName: string;
  contentType: string;
  /** @format byte */
  fileContent: Blob;
  /** @format int64 */
  fileSizeBytes: number;
  /** @format date-time */
  exportedAt: string;
}

export interface GeographyContext {
  /** @maxLength 2000 */
  countries?: string | null;
  /** @maxLength 500 */
  primaryRegions?: string | null;
  /** @maxLength 500 */
  languages?: string | null;
  /** @maxLength 500 */
  timeZones?: string | null;
}

export interface GetChatHistoryResponse {
  messages: ChatHistoryItem[];
  /** @format int32 */
  totalCount: number;
  /** @format int32 */
  page: number;
  /** @format int32 */
  pageSize: number;
  /** @format int32 */
  totalPages: number;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
}

export interface GetConversationFoldersResponse {
  folders: ConversationFolderItem[];
}

export interface GetConversationsResponse {
  conversations: ConversationItem[];
  /** @format int32 */
  totalCount: number;
  /** @format int32 */
  page: number;
  /** @format int32 */
  pageSize: number;
  /** @format int32 */
  totalPages: number;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
}

export interface GroupedEstimationModelResponse {
  /** @format uuid */
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format uuid */
  createdById?: string | null;
  /** @format uuid */
  updatedById?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
  name: string;
  /** @format int32 */
  version: number;
  isPublished: boolean;
  isAiEnabled: boolean;
  /** @format uuid */
  refKey: string;
  /** @format uuid */
  projectTypeId: string;
  isArchived: boolean;
  /** @format int32 */
  publishedVersion: number | null;
}

export interface LocalizationRequest {
  /**
   * @minLength 1
   * @maxLength 100
   */
  key: string;
  /**
   * @minLength 1
   * @maxLength 50000
   */
  value: string;
}

export interface LocalizationResponse {
  key: string;
  value: string;
}

export interface MaintenanceBannerResponse {
  active: boolean;
  type: MaintenanceBannerType;
  message: string;
}

export interface MandatoryDeliverablesContext {
  /** @maxLength 4000 */
  deliverablesList?: string | null;
}

export interface MethodologyParameterRequest {
  /** @format uuid */
  id?: string | null;
  /** @format int32 */
  order: number;
  /** @format uuid */
  labelRefKey: string;
  /**
   * @minLength 1
   * @maxLength 20
   */
  calculationRef: string;
  localizations: AdminLocalizationRequest[];
}

export interface MethodologyParameterResponse {
  /** @format uuid */
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format uuid */
  createdById?: string | null;
  /** @format uuid */
  updatedById?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
  label: string;
  /** @format uuid */
  labelRefKey: string;
  localizations: AdminLocalizationResponse[];
  /** @format int32 */
  order: number;
  calculationRef: string;
}

export interface MethodologyResponse {
  /** @format uuid */
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format uuid */
  createdById?: string | null;
  /** @format uuid */
  updatedById?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
  name: string;
  description?: string | null;
  /** @format uuid */
  nameRefKey: string;
  /** @format uuid */
  descriptionRefKey?: string | null;
  localizations: AdminLocalizationResponse[];
  calculationFormula?: string | null;
  isCurrent: boolean;
  /** @format int32 */
  version: number;
  /** @format int32 */
  order: number;
  defaultParameters: MethodologyParameterResponse[];
}

/**
 * Assigns the conversation to EstiWorld.Api.Models.AiAdvisory.MoveConversationToFolderRequest.FolderId, or removes it from any folder
 * when EstiWorld.Api.Models.AiAdvisory.MoveConversationToFolderRequest.FolderId is null.
 */
export interface MoveConversationToFolderRequest {
  /** @format uuid */
  folderId?: string | null;
}

export interface NoContentResult {
  /** @format int32 */
  statusCode: number;
}

export interface NonFunctionalDefaultsContext {
  /** @maxLength 500 */
  availabilityTarget?: string | null;
  /** @maxLength 2000 */
  performanceExpectations?: string | null;
  /** @maxLength 500 */
  supportHours?: string | null;
  /** @maxLength 2000 */
  environments?: string | null;
  /** @maxLength 2000 */
  documentationExpectations?: string | null;
}

export interface NotificationResponse {
  /** @format uuid */
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format uuid */
  createdById?: string | null;
  /** @format uuid */
  updatedById?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
  isRead: boolean;
  notificationType: NotificationType;
  /** @format uuid */
  estimationId: string;
  /** @format uuid */
  estimationItemId?: string | null;
  /** @format uuid */
  commentId?: string | null;
  /** @format uuid */
  conversationId?: string | null;
  projectName: string;
  reviewOutcome?: ReviewOutcome | null;
}

export interface NotificationResponsePaginatedResponse {
  /** @format int32 */
  totalCount: number;
  items: NotificationResponse[];
}

export interface NotificationTemplateLanguageResponse {
  code: string;
  cultureName: string;
}

/**
 * A fully rendered email preview. EstiWorld.Api.Models.NotificationTemplate.NotificationTemplatePreviewResponse.HtmlBody is the complete HTML document (layout + CTA button);
 * EstiWorld.Api.Models.NotificationTemplate.NotificationTemplatePreviewResponse.TextBody is the plain-text fallback shown by the UI's "Text only" switch.
 */
export interface NotificationTemplatePreviewResponse {
  subject: string;
  htmlBody: string;
  textBody: string;
}

export interface NotificationTemplateResponse {
  subject: string;
  body: string;
  isOverridden: boolean;
}

export interface OrganizationalContext {
  /** @maxLength 500 */
  deliveryModel?: string | null;
  /** @maxLength 2000 */
  methodologies?: string | null;
  /** @maxLength 2000 */
  waysOfWorking?: string | null;
}

export interface PaginatedNotificationResponse {
  /** @format int32 */
  totalCount: number;
  items: NotificationResponse[];
  /** @format int32 */
  totalUnreadCount: number;
}

/**
 * Request to render a full email preview (layout + button) for the given event/language. Subject and Body
 * carry the in-editor (possibly unsaved) values so the preview reflects what the admin is currently editing.
 */
export interface PreviewNotificationTemplateRequest {
  eventType: NotificationType;
  /**
   * @minLength 1
   * @pattern ^(en|de)$
   */
  language: string;
  subject?: string | null;
  body?: string | null;
}

export interface ProblemDetails {
  type?: string | null;
  title?: string | null;
  /** @format int32 */
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
  [key: string]: any;
}

export interface ProblemDetailsWithErrorCode {
  type?: string | null;
  title?: string | null;
  /** @format int32 */
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
  errorCode: ApiErrorCode;
  [key: string]: any;
}

export interface ProjectResponse {
  /** @format uuid */
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format uuid */
  createdById?: string | null;
  /** @format uuid */
  updatedById?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
  name: string;
  /** @format uuid */
  projectTypeId: string;
}

export interface ProjectTypeRequest {
  /** @format uuid */
  id?: string | null;
  /**
   * NameRefKey Guid value is either provided in case of an update or generated by FE for new records
   * @format uuid
   */
  nameRefKey: string;
  /**
   * DescriptionRefKey is optional and the Guid value is either provided in case of an update or generated by FE for new records
   * @format uuid
   */
  descriptionRefKey?: string | null;
  /**
   * @minLength 1
   * @maxLength 1000
   */
  icon: string;
  /** @format int32 */
  order: number;
  localizations: AdminLocalizationRequest[];
}

export interface ProjectTypeResponse {
  /** @format uuid */
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format uuid */
  createdById?: string | null;
  /** @format uuid */
  updatedById?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
  name: string;
  description?: string | null;
  /** @format uuid */
  nameRefKey: string;
  /** @format uuid */
  descriptionRefKey?: string | null;
  localizations: AdminLocalizationResponse[];
  icon: string;
  /** @format int32 */
  order: number;
}

export interface ProjectWithEstimationResponse {
  project: ProjectResponse;
  estimation: EstimationResponse;
}

export interface RegulatoryContext {
  /** @maxLength 4000 */
  applicableRegulations?: string | null;
  /** @maxLength 500 */
  dataSensitivity?: string | null;
  /** @maxLength 2000 */
  compliancePosture?: string | null;
}

export interface RenameConversationFolderRequest {
  /**
   * @minLength 1
   * @maxLength 60
   */
  name: string;
}

export interface RenameConversationRequest {
  /**
   * @minLength 1
   * @maxLength 100
   */
  title: string;
}

export interface RenameEstimationItemRequest {
  /**
   * @minLength 1
   * @maxLength 300
   */
  name: string;
}

export interface ResetNotificationTemplateRequest {
  eventType: NotificationType;
  /**
   * @minLength 1
   * @pattern ^(en|de)$
   */
  language: string;
}

export interface ResourceCostsContext {
  /** @maxLength 4000 */
  dayRatesByCategory?: string | null;
}

export interface ResourceTypeCostResponse {
  /** @format uuid */
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format uuid */
  createdById?: string | null;
  /** @format uuid */
  updatedById?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
  /** @format double */
  price: number;
  /** @format uuid */
  resourceTypeId: string;
  /** @format uuid */
  costTypeId: string;
}

export interface ResourceTypeGroupResponse {
  /** @format uuid */
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format uuid */
  createdById?: string | null;
  /** @format uuid */
  updatedById?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
  name: string;
  description?: string | null;
  /** @format uuid */
  nameRefKey: string;
  /** @format uuid */
  descriptionRefKey?: string | null;
  localizations: AdminLocalizationResponse[];
  /** @format int32 */
  order: number;
  resourceTypes: ResourceTypeResponse[];
}

export interface ResourceTypeResponse {
  /** @format uuid */
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format uuid */
  createdById?: string | null;
  /** @format uuid */
  updatedById?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
  name: string;
  description?: string | null;
  /** @format uuid */
  nameRefKey: string;
  /** @format uuid */
  descriptionRefKey?: string | null;
  localizations: AdminLocalizationResponse[];
  /** @format int32 */
  order: number;
  /** @format uuid */
  costTypeId: string;
  /** @format double */
  resourceCost: number | null;
  userModifiable: boolean | null;
}

export interface ReviewCommentsSummaryCommentResponse {
  text: string;
  reviewerName: string;
  /** @format date-time */
  createdAt: string;
}

export interface ReviewCommentsSummaryGroupResponse {
  elementPath: string;
  contextType: string;
  /** @format uuid */
  estimationItemId?: string | null;
  comments: ReviewCommentsSummaryCommentResponse[];
}

export interface ReviewCommentsSummaryResponse {
  hasComments: boolean;
  noCommentsMessage?: string | null;
  /** @format date-time */
  createdAt?: string | null;
  /** @format int32 */
  versionNumber?: number | null;
  versionName?: string | null;
  groups?: ReviewCommentsSummaryGroupResponse[] | null;
}

export interface RiskCultureContext {
  /** @maxLength 2000 */
  riskAppetite?: string | null;
  /** @maxLength 2000 */
  changeManagementRigor?: string | null;
  /** @maxLength 2000 */
  projectOversightStyle?: string | null;
}

export interface RoleRequest {
  /** @format uuid */
  id?: string | null;
  /**
   * @minLength 1
   * @maxLength 50
   */
  name: string;
  permissions: Permissions;
}

export interface RoleResponse {
  /** @format uuid */
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format uuid */
  createdById?: string | null;
  /** @format uuid */
  updatedById?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
  name: string;
  permissions: Permissions;
}

export interface SaveNotificationTemplateRequest {
  eventType: NotificationType;
  /**
   * @minLength 1
   * @pattern ^(en|de)$
   */
  language: string;
  /** @minLength 1 */
  subject: string;
  /** @minLength 1 */
  body: string;
}

export interface SecurityPostureContext {
  /** @maxLength 500 */
  securityLevel?: string | null;
  /** @maxLength 2000 */
  identityStandards?: string | null;
  /** @maxLength 500 */
  dataClassification?: string | null;
  /** @maxLength 2000 */
  securityReviewExpectation?: string | null;
}

export interface SendMessageRequest {
  /**
   * @minLength 1
   * @maxLength 50000
   */
  content: string;
}

export interface SendMessageResponse {
  /** @format uuid */
  userMessageId: string;
  /** @format uuid */
  assistantMessageId: string;
  response: string;
  /** @format date-time */
  responseAt: string;
  /** @format int32 */
  tokenCount: number;
  /** @format date-span */
  processingTime: string;
}

/**
 * Request to send a test notification email (EWM-689). Subject and Body carry the in-editor (possibly
 * unsaved) values so the test email reflects what the admin is currently editing; ToEmail is the recipient.
 */
export interface SendTestNotificationTemplateEmailRequest {
  eventType: NotificationType;
  /**
   * @minLength 1
   * @pattern ^(en|de)$
   */
  language: string;
  subject?: string | null;
  body?: string | null;
  /**
   * @format email
   * @minLength 1
   */
  toEmail: string;
}

export interface ShareConversationRequest {
  /**
   * @format email
   * @minLength 1
   */
  email: string;
}

export interface SupportedNotificationTemplatesResponse {
  supportedEvents: NotificationType[];
  supportedLanguages: NotificationTemplateLanguageResponse[];
}

export interface TechnologyContext {
  /** @maxLength 500 */
  hostingModel?: string | null;
  /** @maxLength 500 */
  cloudProviders?: string | null;
  /** @maxLength 2000 */
  techStack?: string | null;
  /** @maxLength 2000 */
  integrationPatterns?: string | null;
  /** @maxLength 500 */
  databases?: string | null;
  /** @maxLength 2000 */
  devOpsTooling?: string | null;
}

/**
 * @format uuid
 * @example "temp:5d19b517-ffe7-4ec9-956b-e695c6298bd2"
 */
export type TempGuid = string;

export interface TenantAiContextPayload {
  tenantIdentity?: TenantIdentityContext;
  geography?: GeographyContext;
  regulatory?: RegulatoryContext;
  technology?: TechnologyContext;
  organizational?: OrganizationalContext;
  securityPosture?: SecurityPostureContext;
  nonFunctionalDefaults?: NonFunctionalDefaultsContext;
  resourceCosts?: ResourceCostsContext;
  riskCulture?: RiskCultureContext;
  mandatoryDeliverables?: MandatoryDeliverablesContext;
}

export interface TenantAiInstructionConfigurationResponse {
  /** @format uuid */
  id: string;
  /** @format uuid */
  tenantId: string;
  aiEnabled: boolean;
  instructionsEn?: string | null;
  instructionsDe?: string | null;
  tenantContext?: TenantAiContextPayload;
  /** @format uuid */
  advisoryDefaultModelRefKey?: string | null;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
}

export interface TenantAiStatusResponse {
  aiEnabled: boolean;
  instructionsEn?: string | null;
  instructionsDe?: string | null;
}

export interface TenantExportConfigurationResponse {
  /** @format uuid */
  id: string;
  /** @format uuid */
  tenantId: string;
  tableHeaderFontColor?: string | null;
  tableHeaderBackgroundColor?: string | null;
  tableHeaderFontFamily?: string | null;
  tableHeaderBold?: boolean | null;
  tableHeaderItalic?: boolean | null;
  tableRowFontColor?: string | null;
  tableRowBackgroundColor?: string | null;
  tableRowFontFamily?: string | null;
  tableRowBold?: boolean | null;
  tableRowItalic?: boolean | null;
  tableSummaryFontColor?: string | null;
  tableSummaryBackgroundColor?: string | null;
  tableSummaryFontFamily?: string | null;
  tableSummaryBold?: boolean | null;
  tableSummaryItalic?: boolean | null;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
}

export interface TenantIdentityContext {
  /** @maxLength 500 */
  name?: string | null;
  /** @maxLength 500 */
  industry?: string | null;
  /** @maxLength 500 */
  subIndustry?: string | null;
  /** @maxLength 500 */
  companySize?: string | null;
}

export interface TenantNotificationConfigurationItemRequest {
  notificationType: NotificationType;
  role: ApiEstimationUserAssignmentType;
  deliveryMode: NotificationDeliveryMode;
}

export interface TenantNotificationConfigurationItemResponse {
  notificationType: NotificationType;
  role: ApiEstimationUserAssignmentType;
  deliveryMode: NotificationDeliveryMode;
}

export interface TenantNotificationConfigurationResponse {
  configurations: TenantNotificationConfigurationItemResponse[];
}

export interface TenantResponse {
  /** @format uuid */
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format uuid */
  createdById?: string | null;
  /** @format uuid */
  updatedById?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
  name: string;
  description?: string | null;
  defaultCultureName: string;
  logoUrl?: string | null;
  darkModeLogoUrl?: string | null;
  cssUrl?: string | null;
  isActive: boolean;
  identityProvider: string;
  supportedCultureNames: string[];
  roles: RoleResponse[];
}

export interface TestAiConnectionRequest {
  apiKey?: string | null;
  organizationId?: string | null;
  projectId?: string | null;
  promptId?: string | null;
  promptVersion?: string | null;
}

export interface TestAiConnectionResponse {
  success: boolean;
  message?: string | null;
  errorDetails?: string | null;
}

export interface UpdateEstimationItemAssumptionRequest {
  /** @format uuid */
  estimationModelAssumptionCategoryId?: string | null;
  /**
   * @minLength 1
   * @maxLength 1000
   */
  description: string;
  isValid: boolean;
}

export interface UpdateEstimationItemRequest {
  /**
   * @minLength 1
   * @maxLength 300
   */
  name: string;
  /** @maxLength 1000 */
  description?: string | null;
  isEnabled: boolean;
  isParentBasedCalculation: boolean;
  status: ApiEstimationItemStatus;
  /** @maxLength 1000 */
  omitReason?: string | null;
  /** @format uuid */
  parentId?: string | null;
  unit: EstimationUnit;
  /** @format uuid */
  methodologyId?: string | null;
  /** @format uuid */
  phaseLeadId?: string | null;
  /** @format uuid */
  currencyId?: string | null;
  /**
   * EWM-154 — optional phase deadline that drives the phase-deadline-approaching notifications.
   * @format date-time
   */
  dueDate?: string | null;
  /**
   * EWM-154 — whether the phase is blocked. Toggling this raises a phase blocked/unblocked
   * notification to the phase responsible.
   */
  isBlocked?: boolean | null;
  parameterValues: (number | null)[];
  /**
   * One of EstimationModel Groups' IDs.
   * When estimation item has estimation model item the value must be always set to
   * corresponding estimation model item group ID.
   * @format uuid
   */
  estimationModelGroupId: string;
}

export interface UpdateEstimationItemWithIdRequest {
  /**
   * @minLength 1
   * @maxLength 300
   */
  name: string;
  /** @maxLength 1000 */
  description?: string | null;
  isEnabled: boolean;
  isParentBasedCalculation: boolean;
  status: ApiEstimationItemStatus;
  /** @maxLength 1000 */
  omitReason?: string | null;
  /** @format uuid */
  parentId?: string | null;
  unit: EstimationUnit;
  /** @format uuid */
  methodologyId?: string | null;
  /** @format uuid */
  phaseLeadId?: string | null;
  /** @format uuid */
  currencyId?: string | null;
  /**
   * EWM-154 — optional phase deadline that drives the phase-deadline-approaching notifications.
   * @format date-time
   */
  dueDate?: string | null;
  /**
   * EWM-154 — whether the phase is blocked. Toggling this raises a phase blocked/unblocked
   * notification to the phase responsible.
   */
  isBlocked?: boolean | null;
  parameterValues: (number | null)[];
  /**
   * One of EstimationModel Groups' IDs.
   * When estimation item has estimation model item the value must be always set to
   * corresponding estimation model item group ID.
   * @format uuid
   */
  estimationModelGroupId: string;
  /** @format uuid */
  id: string;
}

export interface UpdateEstimationRequest {
  /**
   * @minLength 1
   * @maxLength 128
   */
  versionName: string;
  unit: EstimationUnit;
  projectDescription?: string | null;
  resourceDisplayNames?: Record<string, string>;
}

export interface UpdateNotificationRequest {
  isRead: boolean;
}

export interface UpdateProjectRequest {
  /**
   * @minLength 1
   * @maxLength 100
   */
  name: string;
}

export interface UpdateProjectWithEstimationRequest {
  project: UpdateProjectRequest;
  estimation: UpdateEstimationRequest;
}

export interface UpdateTenantAiConfigurationRequest {
  aiEnabled?: boolean | null;
  promptId?: string | null;
  promptVersion?: string | null;
  aiScope?: string | null;
  instructionsEn?: string | null;
  instructionsDe?: string | null;
  apiKey?: string | null;
  organizationId?: string | null;
  projectId?: string | null;
  tenantContext?: TenantAiContextPayload;
  /** @format uuid */
  advisoryDefaultModelRefKey?: string | null;
}

export interface UpdateTenantExportConfigurationRequest {
  tableHeaderFontColor?: string | null;
  tableHeaderBackgroundColor?: string | null;
  tableHeaderFontFamily?: string | null;
  tableHeaderBold?: boolean | null;
  tableHeaderItalic?: boolean | null;
  tableRowFontColor?: string | null;
  tableRowBackgroundColor?: string | null;
  tableRowFontFamily?: string | null;
  tableRowBold?: boolean | null;
  tableRowItalic?: boolean | null;
  tableSummaryFontColor?: string | null;
  tableSummaryBackgroundColor?: string | null;
  tableSummaryFontFamily?: string | null;
  tableSummaryBold?: boolean | null;
  tableSummaryItalic?: boolean | null;
}

export interface UpdateTenantNotificationConfigurationRequest {
  configurations: TenantNotificationConfigurationItemRequest[];
}

export interface UpdateTenantRequest {
  /**
   * @minLength 1
   * @maxLength 100
   */
  name: string;
  /** @maxLength 1000 */
  description?: string | null;
  /**
   * @minLength 1
   * @maxLength 10
   */
  defaultCultureName: string;
  isActive: boolean;
  identityProvider?: string | null;
  supportedCultureNames: string[];
  roles: RoleRequest[];
}

export interface UpdateUserRequest {
  /**
   * @minLength 1
   * @maxLength 100
   */
  forename: string;
  /**
   * @minLength 1
   * @maxLength 100
   */
  surname: string;
  /**
   * @minLength 1
   * @maxLength 254
   */
  email: string;
  /**
   * @minLength 1
   * @maxLength 10
   */
  cultureName: string;
  isActive: boolean;
  roleIds: string[];
}

export interface UpsertEstimationAdditionalFieldRequest {
  /** @format uuid */
  id?: string | null;
  /**
   * For DURATION, it must be in format [-][d'.']hh':'mm':'ss['.'fffffff] or null. It doesn't allow unrealistic ranges, e.g. hours portion cannot be bigger than 23.
   * For SELECTABLE, it must contain one of the configured options or null.
   * @minLength 0
   * @maxLength 3000
   */
  value?: string | null;
  /** @format uuid */
  estimationModelAdditionalFieldDefinitionId: string;
}

export interface UpsertEstimationCostRequest {
  /** @format uuid */
  currencyId: string;
  resourceTypeCosts: UpsertResourceTypeCostRequest[];
}

export interface UpsertEstimationItemCostRequest {
  /** @format double */
  price?: number | null;
  /** @format uuid */
  costTypeId: string;
}

export interface UpsertEstimationItemResourceRequest {
  /** @format double */
  value?: number | null;
  /** @format uuid */
  resourceTypeId: string;
}

export interface UpsertEstimationItemsRequest {
  estimationItemsToDelete: string[];
  estimationItemsToUpdate: UpdateEstimationItemWithIdRequest[];
  estimationItemsToCreate: CreateEstimationItemRequest[];
}

export interface UpsertMethodologyRequest {
  /**
   * NameRefKey Guid value is either provided in case of an update or generated by FE for new records
   * @format uuid
   */
  nameRefKey: string;
  /**
   * DescriptionRefKey is optional and the Guid value is either provided in case of an update or generated by FE for new records
   * @format uuid
   */
  descriptionRefKey?: string | null;
  calculationFormula?: string | null;
  /** @format uuid */
  id?: string | null;
  /** @format int32 */
  order: number;
  defaultParameters: MethodologyParameterRequest[];
  localizations: AdminLocalizationRequest[];
}

export interface UpsertResourceTypeCostRequest {
  /** @format double */
  price: number;
  /** @format uuid */
  resourceTypeId: string;
}

export interface UserLatestEstimationResponse {
  /** @format uuid */
  estimationId: string;
  estimationStage: ApiEstimationStage;
  /** @format uuid */
  projectId: string;
  projectName: string;
  /** @format date-time */
  changedAt: string;
}

export interface UserResponse {
  /** @format uuid */
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format uuid */
  createdById?: string | null;
  /** @format uuid */
  updatedById?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
  forename: string;
  surname: string;
  email: string;
  cultureName: string;
  isActive: boolean;
  roleIds: string[];
}

export interface UserResponsePaginatedResponse {
  /** @format int32 */
  totalCount: number;
  items: UserResponse[];
}

export interface UserWithTempPasswordResponse {
  /** @format uuid */
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format uuid */
  createdById?: string | null;
  /** @format uuid */
  updatedById?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
  forename: string;
  surname: string;
  email: string;
  cultureName: string;
  isActive: boolean;
  roleIds: string[];
  tempPassword: string;
}

export interface ValidationProblemDetailsWithErrorCode {
  type?: string | null;
  title?: string | null;
  /** @format int32 */
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
  errors: Record<string, string[]>;
  errorCode: ApiErrorCode;
  [key: string]: any;
}

export interface SetEstimationModeRequest {
  mode: ApiEstimationMode;
}

export type V1AiAdvisoryConversationsCreateError = ProblemDetails | ProblemDetailsWithErrorCode;

export type V1AiAdvisoryConversationsListError = ProblemDetails | ProblemDetailsWithErrorCode;

export type V1AiAdvisoryConversationsMessagesStreamCreateError =
  | ProblemDetails
  | ProblemDetailsWithErrorCode;

export type V1AiAdvisoryConversationsMessagesCreateError =
  | ProblemDetails
  | ProblemDetailsWithErrorCode;

export type V1AiAdvisoryChatHistoryListError = ProblemDetails | ProblemDetailsWithErrorCode;

export type V1AiAdvisoryConversationsExportCreateError =
  | ProblemDetails
  | ProblemDetailsWithErrorCode;

export type V1AiAdvisoryConversationsConvertToEstimationCreateError =
  | ProblemDetails
  | ProblemDetailsWithErrorCode;

export type V1AiAdvisoryConversationsShareCreateError =
  | ProblemDetails
  | ProblemDetailsWithErrorCode;

export type V1AiAdvisoryConversationsPartialUpdateError =
  | ProblemDetails
  | ProblemDetailsWithErrorCode;

export type V1AiAdvisoryConversationsDeleteError = ProblemDetails | ProblemDetailsWithErrorCode;

export type V1AiAdvisoryFoldersListError = ProblemDetails | ProblemDetailsWithErrorCode;

export type V1AiAdvisoryFoldersCreateError = ProblemDetails | ProblemDetailsWithErrorCode;

export type V1AiAdvisoryFoldersPartialUpdateError = ProblemDetails | ProblemDetailsWithErrorCode;

export type V1AiAdvisoryFoldersDeleteError = ProblemDetails | ProblemDetailsWithErrorCode;

export type V1AiAdvisoryConversationsFolderPartialUpdateError =
  | ProblemDetails
  | ProblemDetailsWithErrorCode;

export type V1AuthLoginCreateError = ProblemDetails;

export type V1EstimationsCommentsListError = NoContentResult | ProblemDetailsWithErrorCode;

export type V1EstimationItemsCommentsListError = NoContentResult | ProblemDetailsWithErrorCode;

export type V1CommentsCreateError = NoContentResult | ProblemDetailsWithErrorCode;

export type V1CurrenciesListError = NoContentResult | ProblemDetailsWithErrorCode;

export type V1EstimationsListError = NoContentResult | ProblemDetailsWithErrorCode;

export type V1EstimationsCreateError =
  | ValidationProblemDetailsWithErrorCode
  | NoContentResult
  | ProblemDetailsWithErrorCode;

export type V1EstimationsUpdateError =
  | ValidationProblemDetailsWithErrorCode
  | NoContentResult
  | ProblemDetailsWithErrorCode;

export type V1EstimationsDetailError = NoContentResult | ProblemDetailsWithErrorCode;

export type V1EstimationsVersionCreateError =
  | NoContentResult
  | ProblemDetails
  | ProblemDetailsWithErrorCode;

export type V1EstimationsInProcessCreateError = ProblemDetailsWithErrorCode | NoContentResult;

export type V1EstimationsReviewCreateError = ProblemDetailsWithErrorCode | NoContentResult;

export type V1EstimationsReviewDeleteError = ProblemDetailsWithErrorCode | NoContentResult;

export type V1EstimationsApprovalCreateError = ProblemDetailsWithErrorCode | NoContentResult;

export type V1EstimationsReviewCommentsSummaryListError =
  | NoContentResult
  | ProblemDetailsWithErrorCode;

export type V1EstimationsAdditionalFieldsListError = NoContentResult | ProblemDetailsWithErrorCode;

export type V1EstimationsAdditionalFieldsUpdateError =
  | ValidationProblemDetailsWithErrorCode
  | NoContentResult
  | ProblemDetailsWithErrorCode;

export type V1EstimationsEstimationItemsAssumptionsListError =
  | NoContentResult
  | ProblemDetailsWithErrorCode;

export type V1EstimationsAiReviewCreateError = NoContentResult | ProblemDetailsWithErrorCode;

export type V1EstimationsAiReviewDetailError = NoContentResult | ProblemDetailsWithErrorCode;

export type V1EstimationsDeleteWholeProjectDeleteError =
  | NoContentResult
  | ProblemDetails
  | ProblemDetailsWithErrorCode;

export type V1EstimationsCostsListError = NoContentResult | ProblemDetailsWithErrorCode;

export type V1EstimationsCostsUpdateError = ProblemDetailsWithErrorCode | NoContentResult;

export type V1EstimationsInitialEstimationItemsCreateError =
  | NoContentResult
  | ProblemDetails
  | ProblemDetailsWithErrorCode;

export type V1EstimationsEstimationItemsCreateError =
  | ValidationProblemDetailsWithErrorCode
  | NoContentResult
  | ProblemDetailsWithErrorCode;

export type V1EstimationsEstimationItemsListError = NoContentResult | ProblemDetailsWithErrorCode;

export type V1EstimationsEstimationItemsPartialUpdateError =
  | ValidationProblemDetailsWithErrorCode
  | NoContentResult
  | ProblemDetailsWithErrorCode;

export type V1EstimationItemsDeleteError = NoContentResult | ProblemDetailsWithErrorCode;

export type V1EstimationItemsUpdateError =
  | ValidationProblemDetailsWithErrorCode
  | NoContentResult
  | ProblemDetailsWithErrorCode;

export type V1EstimationItemsDetailError = NoContentResult | ProblemDetailsWithErrorCode;

export type V1EstimationItemsNamePartialUpdateError =
  | ValidationProblemDetailsWithErrorCode
  | NoContentResult
  | ProblemDetailsWithErrorCode;

export type V1EstimationItemsAssumptionsDetailError = NoContentResult | ProblemDetailsWithErrorCode;

export type V1EstimationItemsAssumptionsUpdateError = ProblemDetailsWithErrorCode | NoContentResult;

export type V1EstimationItemsAssumptionsDeleteError = NoContentResult | ProblemDetailsWithErrorCode;

export type V1EstimationItemsAssumptionsListError = NoContentResult | ProblemDetailsWithErrorCode;

export type V1EstimationItemsAssumptionsCreateError = ProblemDetailsWithErrorCode | NoContentResult;

export type V1EstimationsEstimationItemCostsListError =
  | NoContentResult
  | ProblemDetailsWithErrorCode;

export type V1EstimationItemsCostsListError = NoContentResult | ProblemDetailsWithErrorCode;

export type V1EstimationItemsCostsUpdateError = ProblemDetailsWithErrorCode | NoContentResult;

export type V1EstimationsResourcesListError = NoContentResult | ProblemDetailsWithErrorCode;

export type V1EstimationItemsResourcesListError = NoContentResult | ProblemDetailsWithErrorCode;

export type V1EstimationItemsResourcesUpdateError = ProblemDetailsWithErrorCode | NoContentResult;

export type V1EstimationModelsCreateError = ProblemDetailsWithErrorCode | NoContentResult;

export type V1EstimationModelsListError = NoContentResult | ProblemDetailsWithErrorCode;

export type V1EstimationModelsDetailError = NoContentResult | ProblemDetailsWithErrorCode;

export type V1EstimationModelsDeleteError = NoContentResult | ProblemDetailsWithErrorCode;

export type V1EstimationModelsGroupedListError = NoContentResult | ProblemDetailsWithErrorCode;

export type V1EstimationModelsPublishCreateError = ProblemDetailsWithErrorCode | NoContentResult;

export type V1EstimationModelsAffectedEstimationsCountListError =
  | NoContentResult
  | ProblemDetailsWithErrorCode;

export type V1EstimationModelsArchiveCreateError = NoContentResult | ProblemDetailsWithErrorCode;

export type V1EstimationModelsReactivateCreateError = NoContentResult | ProblemDetailsWithErrorCode;

export type V1EstimationsUsersUpdateError = ProblemDetailsWithErrorCode | NoContentResult;

export type V1EstimationsUsersListError = NoContentResult | ProblemDetailsWithErrorCode;

export type V1EstimationsPermissionsListError = NoContentResult | ProblemDetailsWithErrorCode;

export type V1LocalizationsFrontendUpdateError =
  | ProblemDetails
  | NoContentResult
  | ProblemDetailsWithErrorCode;

export type V1LocalizationsFrontendDetailError =
  | NoContentResult
  | ProblemDetails
  | ProblemDetailsWithErrorCode;

export type V1LocalizationsBackendUpdateError =
  | ProblemDetails
  | NoContentResult
  | ProblemDetailsWithErrorCode;

export type V1LocalizationsBackendDetailError =
  | NoContentResult
  | ProblemDetails
  | ProblemDetailsWithErrorCode;

export type V1MethodologiesListError =
  | NoContentResult
  | ProblemDetails
  | ProblemDetailsWithErrorCode;

export type V1MethodologiesUpdateError =
  | ProblemDetails
  | NoContentResult
  | ProblemDetailsWithErrorCode;

export type V1NotificationsListError = NoContentResult | ProblemDetailsWithErrorCode;

export type V1NotificationsUpdateError =
  | ProblemDetails
  | NoContentResult
  | ProblemDetailsWithErrorCode;

export type V1TenantNotificationTemplatesSupportedListError =
  | NoContentResult
  | ProblemDetailsWithErrorCode;

export type V1TenantNotificationTemplatesListError =
  | ProblemDetails
  | NoContentResult
  | ProblemDetailsWithErrorCode;

export type V1TenantNotificationTemplatesUpdateError =
  | ProblemDetails
  | NoContentResult
  | ProblemDetailsWithErrorCode;

export type V1TenantNotificationTemplatesPreviewCreateError =
  | ProblemDetails
  | NoContentResult
  | ProblemDetailsWithErrorCode;

export type V1TenantNotificationTemplatesSendTestCreateError =
  | ProblemDetails
  | NoContentResult
  | ProblemDetailsWithErrorCode;

export type V1TenantNotificationTemplatesResetCreateError =
  | ProblemDetails
  | NoContentResult
  | ProblemDetailsWithErrorCode;

export type V1PermissionsListError = NoContentResult | ProblemDetailsWithErrorCode;

export type V1ProjectTypesListError = NoContentResult | ProblemDetailsWithErrorCode;

export type V1ProjectTypesUpdateError =
  | ProblemDetails
  | NoContentResult
  | ProblemDetailsWithErrorCode;

export type V1TenantListError = NoContentResult | ProblemDetailsWithErrorCode;

export type V1TenantUpdateError = ProblemDetails | NoContentResult | ProblemDetailsWithErrorCode;

export type V1TenantLogoUpdateError =
  | ProblemDetails
  | NoContentResult
  | ProblemDetailsWithErrorCode;

export type V1TenantCssUrlUpdateError =
  | ProblemDetails
  | NoContentResult
  | ProblemDetailsWithErrorCode;

export type V1TenantAiStatusListError = ProblemDetails | ProblemDetailsWithErrorCode;

export type V1TenantAiConfigListError = ProblemDetails | ProblemDetailsWithErrorCode;

export type V1TenantAiConfigUpdateError = ProblemDetails | ProblemDetailsWithErrorCode;

export type V1TenantAiConfigTestCreateError =
  | TestAiConnectionResponse
  | ProblemDetails
  | ProblemDetailsWithErrorCode;

export type V1TenantExportConfigListError = ProblemDetails | ProblemDetailsWithErrorCode;

export type V1TenantExportConfigUpdateError = ProblemDetails | ProblemDetailsWithErrorCode;

export type V1TenantNotificationConfigurationListError =
  | ProblemDetails
  | ProblemDetailsWithErrorCode;

export type V1TenantNotificationConfigurationUpdateError =
  | ProblemDetails
  | ProblemDetailsWithErrorCode;

export type V1UsersCurrentListError = ProblemDetailsWithErrorCode;

export type V1UsersCurrentLatestActiveEstimationListError = ProblemDetailsWithErrorCode;

export type V1UsersDetailError = NoContentResult | ProblemDetails | ProblemDetailsWithErrorCode;

export type V1UsersUpdateError = ProblemDetails | NoContentResult | ProblemDetailsWithErrorCode;

export type V1UsersDeleteError = NoContentResult | ProblemDetails | ProblemDetailsWithErrorCode;

export type V1UsersListError = NoContentResult | ProblemDetails | ProblemDetailsWithErrorCode;

export type V1UsersCreateError = ProblemDetails | NoContentResult | ProblemDetailsWithErrorCode;

export type V1EstimationsModeCreateError = ProblemDetailsWithErrorCode | NoContentResult;
